{
  "segments":{
    "á":"22:23.11-0.45,24.56-0.4,25.96-0.37",
    "à":"22:0-0.41",
    "ā":"22:44.09-0.32,45.41-0.36",
    "ái":"22:27.33-0.49,28.82-0.43,30.25-0.51,31.76-0.56",
    "ài":"22:1.41-0.39,2.8-0.33,4.13-0.3,5.43-0.4",
    "ǎi":"22:70.94-0.96,72.9-0.51,74.41-0.43,75.84-0.71",
    "āi":"22:46.77-0.41,48.18-0.36,49.54-0.4",
    "àn":"22:6.83-0.32,8.15-0.36,9.51-0.35,10.86-0.33",
    "ǎn":"22:77.55-0.71",
    "ān":"22:50.94-0.46,52.4-0.38,53.78-0.48,55.26-0.43",
    "áng":"22:33.31-0.44,34.75-0.46",
    "àng":"22:12.19-0.31,13.5-0.41,14.91-0.47,16.38-0.4",
    "āng":"22:56.69-0.47,58.16-0.44,59.6-0.44,61.04-0.46",
    "áo":"22:36.21-0.49,37.7-0.43,39.13-0.53,40.65-0.52,42.18-0.91",
    "ào":"22:17.78-0.31,19.09-0.35,20.44-0.36,21.8-0.31",
    "ǎo":"22:79.26-0.5,80.76-0.89,82.65-0.51,84.16-0.73,85.89-0.61",
    "āo":"22:62.5-0.37,63.87-0.4,65.27-0.38,66.65-0.37,68.02-0.39,69.41-0.53",
    "bá":"0:54.51-0.41,55.92-0.37,57.29-0.48,58.77-0.39,60.16-0.38",
    "bà":"0:25.69-0.26,26.95-0.44,28.39-0.29,29.68-0.23",
    "bǎ":"0:210.97-0.49",
    "bā":"0:125.02-0.52,126.54-0.36,127.9-0.3,129.2-0.27",
    "bái":"0:61.54-0.39,62.93-0.6,64.53-0.39,65.92-0.36,67.28-0.36",
    "bài":"0:30.91-0.41,32.32-0.29,33.6-0.33,34.93-0.26",
    "bǎi":"0:212.46-0.5,213.96-0.36,215.32-0.39",
    "bāi":"0:130.47-0.31,131.78-0.31,133.09-0.47,134.56-0.33,135.89-0.36",
    "bàn":"0:36.19-0.33,37.52-0.31,38.83-0.32,40.15-0.4",
    "bǎn":"0:216.71-0.56,218.26-0.54",
    "bān":"0:137.25-0.51,138.76-0.34,140.1-0.3,141.4-0.34",
    "bàng":"0:41.55-0.29,42.84-0.35,44.19-0.29,45.47-0.35,46.82-0.37",
    "bǎng":"0:219.8-0.39,221.19-0.43,222.62-0.45",
    "bāng":"0:142.74-0.38,144.12-0.32,145.44-0.35,146.79-0.46,148.25-0.35",
    "báo":"0:68.64-0.43,70.07-0.43,71.5-0.38,72.88-0.4",
    "bào":"0:48.19-0.29,49.48-0.25,50.73-0.3,52.03-0.18,53.21-0.3",
    "bǎo":"0:224.07-0.44,225.51-0.5,227.01-0.57,228.58-0.48,230.06-0.86",
    "bāo":"0:149.6-0.36,150.96-0.3,152.26-0.36,153.62-0.42",
    "bèi":"0:74.28-0.25,75.53-0.31,76.84-0.31,78.15-0.57,79.71-0.29",
    "běi":"0:172.71-0.54,174.25-0.38,175.63-0.42",
    "bēi":"0:155.04-0.54,156.58-0.45,158.03-0.3,159.33-0.29",
    "bèn":"0:81-0.29,82.28-0.3,83.58-0.3,84.88-0.27,86.15-0.49",
    "běn":"0:177.05-0.57,178.61-1.11,180.71-0.84,182.55-0.49,184.04-0.39",
    "bēn":"0:160.61-0.29,161.9-0.3,163.2-0.47,164.67-0.29,165.96-0.33",
    "béng":"0:91.65-0.35,93-0.34,94.34-0.34",
    "bèng":"0:87.64-0.39,89.03-0.29,90.31-0.34",
    "běng":"0:185.43-0.54",
    "bēng":"0:167.29-0.34,168.63-0.35,169.98-0.36,171.34-0.37",
    "bí":"0:101.08-0.45,102.53-0.61",
    "bì":"0:95.68-0.4,97.08-0.38",
    "bǐ":"0:231.92-0.51,233.43-0.92,235.35-0.42,236.77-0.57",
    "bī":"0:186.97-0.66,188.63-0.44",
    "biàn":"0:0-0.42,1.42-0.33",
    "biǎn":"0:21.11-0.68",
    "biān":"0:11.41-0.33,12.74-0.37,14.11-0.36",
    "biào":"0:2.75-0.39",
    "biǎo":"0:22.79-0.44,24.23-0.46",
    "biāo":"0:15.47-0.35,16.82-0.49",
    "bié":"0:4.14-0.56,5.69-0.35,7.04-0.5,8.53-0.46,10-0.41",
    "biě":"0:19.64-0.46",
    "biē":"0:18.3-0.34",
    "bìn":"0:98.46-0.31",
    "bīn":"0:190.07-0.39,191.46-0.36,192.82-0.4",
    "bìng":"0:99.77-0.31",
    "bǐng":"0:238.33-0.48,239.81-0.45",
    "bīng":"0:194.22-0.41,195.63-0.32,196.95-0.66",
    "bó":"0:110.74-0.84,112.58-0.38,113.96-0.37,115.33-0.37,116.7-0.41",
    "bò":"0:104.14-0.29,105.43-0.29,106.71-0.42,108.13-0.26,109.39-0.35",
    "bǒ":"0:241.26-0.37,242.63-0.32,243.95-0.35",
    "bō":"0:198.61-0.45,200.06-0.39,201.45-0.36,202.81-0.37,204.18-0.33",
    "bú":"0:123.28-0.74",
    "bù":"0:118.11-0.34,119.45-0.25,120.7-0.24,121.94-0.34",
    "bǔ":"0:245.3-0.43,246.73-0.43,248.16-0.57",
    "bū":"0:205.51-0.32,206.83-0.32,208.15-0.52,209.67-0.3",
    "cǎ":"2:185.23-0.53,186.76-0.67",
    "cā":"2:127.96-0.57,129.52-0.58,131.1-0.39,132.49-0.56",
    "cái":"2:47.62-0.57,49.18-0.54,50.72-0.49,52.21-0.69",
    "cài":"2:28.74-0.51,30.25-0.37,31.62-0.45,33.07-0.5",
    "cǎi":"2:188.43-0.59",
    "cāi":"2:134.04-0.57,135.6-0.54,137.14-0.49,138.63-0.41",
    "cán":"2:53.9-0.57,55.46-0.69,57.15-0.62,58.77-0.66",
    "càn":"2:34.57-0.4,35.97-0.54,37.51-0.41,38.92-0.41,40.33-0.51",
    "cǎn":"2:190.02-0.48,191.5-0.54,193.04-0.63,194.67-0.57,196.23-0.89",
    "cān":"2:140.04-0.58,141.62-0.4,143.02-0.52,144.54-0.46,146-0.53,147.53-0.44,148.97-0.49,150.46-0.59,152.05-0.57,153.62-0.57",
    "cáng":"2:60.43-0.49,61.92-0.74,63.66-0.58",
    "cāng":"2:155.19-0.44,156.63-0.54,158.17-0.57",
    "cáo":"2:65.23-0.65,66.89-0.43",
    "cào":"2:41.84-0.5,43.34-0.36,44.7-0.48,46.18-0.44",
    "cǎo":"2:198.12-0.74,199.86-0.61,201.47-0.62,203.09-0.71,204.8-0.63,206.43-0.53,207.96-0.59,209.55-0.54",
    "cāo":"2:159.73-0.5,161.23-0.54,162.77-0.46,164.23-0.49",
    "cè":"2:68.31-0.5,69.81-0.63,71.45-0.39,72.84-0.38,74.22-0.51",
    "cén":"2:83.05-0.54",
    "céng":"2:84.59-0.62,86.21-0.58,87.79-0.54,89.33-0.66",
    "cèng":"2:75.73-0.42,77.15-0.39,78.54-0.59,80.13-0.5,81.63-0.42",
    "cēng":"2:165.72-0.39,167.11-0.39,168.5-0.6,170.1-0.46",
    "chá":"1:84.39-0.57,85.95-0.56,87.5-0.65,89.15-0.46,90.61-0.57,92.18-0.53",
    "chà":"1:64.61-0.38,65.99-0.42,67.41-0.36,68.77-0.38",
    "chǎ":"1:274.35-0.46,275.81-0.7,277.51-0.57",
    "chā":"1:192.03-0.54,193.57-0.43",
    "chái":"1:93.71-0.57,95.27-0.5,96.77-0.63,98.4-0.47,99.87-0.52",
    "chài":"1:70.15-0.37,71.52-0.38,72.9-0.46,74.36-0.39",
    "chāi":"1:195-0.51,196.51-0.4,197.91-0.37,199.28-0.56,200.83-0.39",
    "chán":"1:101.39-0.64",
    "chàn":"1:75.75-0.43,77.18-0.41,78.59-0.38,79.97-0.37",
    "chǎn":"1:279.07-0.47,280.54-0.54",
    "chān":"1:202.22-0.44,203.66-0.42,205.08-0.5",
    "cháng":"1:103.03-0.62,104.65-0.62,106.27-0.47,107.74-0.59",
    "chàng":"1:81.34-0.56,82.89-0.5",
    "chǎng":"1:282.08-0.76,283.84-0.65,285.49-0.57,287.05-0.5,288.55-0.57",
    "chāng":"1:206.58-0.41,207.99-0.5,209.49-0.5",
    "cháo":"1:109.33-0.6,110.93-0.57,112.49-0.74",
    "chǎo":"1:290.12-0.7,291.82-0.6",
    "chāo":"1:210.99-0.53,212.52-0.46,213.98-0.54",
    "chè":"1:114.23-0.37,115.6-0.42,117.02-0.56",
    "chě":"1:230.05-0.64,231.69-0.71,233.4-0.69,235.09-0.56,236.64-0.47",
    "chē":"1:215.52-0.45,216.97-0.5,218.47-0.47",
    "chén":"1:132.67-0.59,134.26-0.66,135.92-0.57,137.48-0.54,139.02-0.57",
    "chèn":"1:118.57-0.36,119.93-0.5,121.43-0.44,122.87-0.41,124.28-0.4",
    "chěn":"1:238.11-0.53,239.64-0.57,241.21-0.45",
    "chēn":"1:219.94-0.49,221.43-0.57,222.99-0.41",
    "chéng":"1:140.59-0.5,142.09-0.48,143.57-0.58,145.15-0.72,146.87-0.45,148.32-0.46,149.78-0.48",
    "chèng":"1:125.68-0.41,127.09-0.47,128.56-0.4,129.96-0.38,131.34-0.33",
    "chěng":"1:242.66-1.2,244.86-0.57,246.43-0.51,247.94-0.46",
    "chēng":"1:224.4-0.45,225.85-0.37,227.22-0.46,228.68-0.37",
    "chí":"1:155.45-0.52,156.97-0.41,158.38-0.41,159.79-0.46,161.25-0.6",
    "chì":"1:151.26-0.36,152.62-0.36,153.98-0.47",
    "chǐ":"1:293.42-0.46,294.88-1.54,297.42-0.67,299.09-0.65,300.74-0.56",
    "chī":"1:249.4-0.41,250.81-0.46,252.27-0.59",
    "chóng":"1:174.42-0.51,175.93-0.65",
    "chòng":"1:162.85-0.35,164.2-0.43,165.63-0.46",
    "chǒng":"1:302.29-0.63,303.92-0.62",
    "chōng":"1:253.86-0.39,255.25-0.42,256.67-0.51",
    "chóu":"1:177.58-0.43",
    "chòu":"1:167.09-0.4,168.49-0.4,169.89-0.4,171.29-0.56,172.84-0.58",
    "chǒu":"1:305.54-0.5,307.04-0.72,308.76-0.57,310.32-0.53,311.85-0.47",
    "chōu":"1:258.18-0.45,259.63-0.51,261.14-0.56,262.69-0.5",
    "chú":"1:183.12-0.49,184.61-0.47,186.08-0.5",
    "chù":"1:179.01-0.36,180.37-0.34,181.71-0.41",
    "chǔ":"1:313.32-0.54,314.86-0.6,316.46-0.53",
    "chū":"1:264.19-0.44,265.63-0.49,267.12-0.47,268.59-0.43",
    "chuā":"1:35.58-0.47",
    "chuái":"1:11.72-0.57,13.28-0.52,14.8-0.5",
    "chuài":"1:0-0.54",
    "chuǎi":"1:55.01-0.46",
    "chuāi":"1:37.04-0.45,38.5-0.46",
    "chuán":"1:16.3-0.5,17.8-0.5",
    "chuàn":"1:1.54-0.42,2.96-0.64,4.59-0.39",
    "chuǎn":"1:56.47-0.74,58.21-0.6",
    "chuān":"1:39.96-0.4",
    "chuáng":"1:19.3-0.58,20.88-0.53,22.41-0.5",
    "chuàng":"1:5.99-0.45,7.44-0.4,8.84-0.47,10.31-0.41",
    "chuǎng":"1:59.81-0.49,61.3-0.6,62.9-0.71",
    "chuāng":"1:41.36-0.57,42.93-0.6,44.53-0.45",
    "chuí":"1:23.91-0.56,25.46-0.52,26.98-0.57",
    "chuī":"1:45.98-0.48,47.46-0.5,48.96-0.45",
    "chún":"1:187.58-0.52,189.1-0.45,190.55-0.48",
    "chǔn":"1:317.99-0.56,319.54-0.46",
    "chūn":"1:270.02-0.48,271.5-0.43,272.93-0.42",
    "chuò":"1:28.55-0.4,29.95-0.39,31.34-0.43,32.77-0.38,34.15-0.43",
    "chuō":"1:50.41-0.47,51.88-0.59,53.47-0.54",
    "cí":"2:101.09-0.42,102.51-0.64",
    "cì":"2:90.99-0.57,92.55-0.45,94-0.49,95.49-0.34,96.83-0.34,98.17-0.43,99.6-0.49",
    "cǐ":"2:211.09-0.74,212.83-0.61",
    "cī":"2:171.56-0.47",
    "cóng":"2:111.37-0.52,112.89-0.48,114.37-0.41,115.78-0.52",
    "cōng":"2:173.03-0.56,174.58-0.45,176.03-0.56,177.58-0.48",
    "còu":"2:104.15-0.54,105.69-0.38,107.07-0.44,108.51-0.51,110.02-0.35",
    "cú":"2:123.13-0.48",
    "cù":"2:117.3-0.38,118.68-0.61",
    "cū":"2:179.06-0.47,180.53-0.61,182.14-0.59",
    "cuàn":"2:0-0.38,1.38-0.42",
    "cuān":"2:13.46-0.46,14.92-0.56,16.47-0.58",
    "cuì":"2:2.8-0.53,4.33-0.38",
    "cuǐ":"2:23.99-0.62",
    "cuī":"2:18.05-0.46,19.51-0.49",
    "cún":"2:124.61-0.61,126.22-0.74",
    "cùn":"2:120.29-0.42,121.71-0.42",
    "cūn":"2:183.73-0.5",
    "cuó":"2:8.6-0.59,10.19-0.71,11.9-0.57",
    "cuò":"2:5.71-0.42,7.13-0.47",
    "cuǒ":"2:25.61-0.56,27.16-0.58",
    "cuō":"2:21-0.51,22.51-0.48",
    "dá":"3:136.78-0.44,138.22-0.36,139.58-0.54,141.12-0.4,142.52-0.45",
    "dà":"3:105.13-0.31,106.44-0.26,107.7-0.25,108.95-0.44,110.39-0.26",
    "dǎ":"3:268.16-0.42,269.58-0.45,271.03-0.39,272.42-0.37",
    "dā":"3:190.53-0.49,192.02-0.39,193.41-0.52",
    "dài":"3:111.65-0.26,112.91-0.24,114.15-0.29,115.44-0.29,116.72-0.29",
    "dǎi":"3:273.79-0.54,275.33-0.42,276.75-0.37,278.12-0.45",
    "dāi":"3:194.93-0.41,196.34-0.35,197.69-0.34,199.03-0.31,200.34-0.35",
    "dàn":"3:118-0.42,119.42-0.4,120.82-0.32,122.14-0.31,123.45-0.31",
    "dǎn":"3:279.57-0.41,280.98-0.52,282.5-0.54,284.04-0.5,285.54-0.4",
    "dān":"3:201.69-0.61,203.3-0.42,204.72-0.4,206.12-0.33,207.45-0.37",
    "dàng":"3:124.76-0.3,126.06-0.42,127.48-0.35,128.83-0.39",
    "dǎng":"3:286.94-0.45,288.39-0.39,289.78-0.36,291.14-0.51",
    "dāng":"3:208.82-0.63,210.45-0.4,211.85-0.5,213.35-0.3,214.65-0.31",
    "dào":"3:130.22-0.3,131.52-0.31,132.83-0.27,134.1-0.3,135.4-0.38",
    "dǎo":"3:292.65-0.6,294.25-0.56,295.8-0.44",
    "dāo":"3:215.96-0.35,217.31-0.29,218.6-0.34,219.94-0.35,221.29-0.42",
    "dé":"3:148.04-0.58,149.62-0.46,151.08-0.33",
    "dē":"3:222.71-0.42,224.13-0.31,225.44-0.37",
    "dèng":"3:143.97-0.46,145.43-0.31,146.74-0.3",
    "děng":"3:233.5-0.46,234.96-0.44",
    "dēng":"3:226.81-0.43,228.24-0.26,229.5-0.31,230.81-0.38,232.19-0.31",
    "dí":"3:159.36-0.46,160.82-0.57,162.38-0.39",
    "dì":"3:152.41-0.44,153.85-0.48",
    "dǐ":"3:297.24-0.5,298.74-0.7,300.44-0.43,301.87-0.43,303.3-0.54",
    "dī":"3:236.4-0.31,237.71-0.38,239.09-0.57",
    "diǎ":"3:32.13-0.46,33.59-0.47",
    "diàn":"3:0-0.3,1.3-0.35,2.65-0.45,4.09-0.36",
    "diǎn":"3:35.06-0.49,36.54-0.51,38.06-0.42,39.47-0.47",
    "diān":"3:13.93-0.46,15.39-0.4,16.79-0.49,18.28-0.38",
    "diào":"3:5.46-0.43",
    "diǎo":"3:40.95-0.42,42.37-0.7,44.07-0.43,45.5-0.52",
    "diāo":"3:19.66-0.37,21.03-0.39",
    "dié":"3:6.89-0.36,8.25-0.53,9.77-0.34,11.12-0.49,12.61-0.32",
    "diē":"3:22.42-0.38,23.8-0.52,25.32-0.37,26.69-0.34",
    "dìng":"3:155.33-0.32,156.65-0.32,157.97-0.39",
    "dǐng":"3:304.84-0.4,306.24-0.48",
    "dīng":"3:240.65-0.4,242.05-0.41,243.46-0.36",
    "diū":"3:28.03-0.38,29.41-0.35,30.76-0.37",
    "dòng":"3:163.77-0.4,165.17-0.27,166.44-0.27,167.71-0.31",
    "dǒng":"3:307.72-1.01,309.73-0.42,311.15-0.4",
    "dōng":"3:244.82-0.33,246.15-0.31,247.46-0.3,248.76-0.29,250.05-0.29",
    "dòu":"3:169.02-0.31,170.33-0.27",
    "dǒu":"3:312.55-0.39,313.94-0.32,315.26-0.35,316.61-0.38,317.99-0.47",
    "dōu":"3:251.33-0.36,252.69-0.5,254.19-0.35,255.54-0.37,256.91-0.34",
    "dú":"3:183.48-0.38,184.86-0.33,186.19-0.46,187.65-0.51,189.16-0.37",
    "dù":"3:171.6-0.29,172.88-0.25,174.13-0.36,175.49-0.38",
    "dǔ":"3:319.46-0.46",
    "dū":"3:258.25-0.3,259.55-0.35",
    "duàn":"3:47.02-0.33,48.35-0.54,49.89-0.57,51.45-0.46,52.91-0.33",
    "duǎn":"3:89.7-0.65,91.35-1.15,93.5-0.45,94.95-0.45,96.4-0.49",
    "duān":"3:70.06-0.5,71.56-0.41,72.98-0.41,74.39-0.33,75.72-0.4",
    "duì":"3:54.24-0.25,55.49-0.23,56.72-0.46,58.18-0.36",
    "duī":"3:77.12-0.36,78.48-0.76,80.23-0.33,81.56-0.34",
    "dùn":"3:176.87-0.3,178.17-0.29,179.45-0.31,180.76-0.46,182.22-0.26",
    "dǔn":"3:320.92-0.53,322.45-0.5,323.95-0.48,325.43-0.42,326.85-0.5",
    "dūn":"3:260.9-0.46,262.36-0.3,263.66-0.38,265.04-0.31,266.35-0.81",
    "duó":"3:65.93-0.38,67.31-0.41,68.72-0.35",
    "duò":"3:59.54-0.27,60.81-0.29,62.09-0.29,63.38-0.31,64.69-0.24",
    "duǒ":"3:97.89-0.47,99.36-0.34,100.7-0.56,102.25-0.34,103.59-0.54",
    "duō":"3:82.91-0.32,84.23-0.35,85.58-0.34,86.92-0.49,88.41-0.29",
    "é":"23:15.78-0.31",
    "è":"23:0-0.47,1.47-0.35,2.82-0.27",
    "ě":"23:40.78-0.32,42.1-0.31,43.41-0.32,44.73-0.26",
    "ē":"23:21.29-0.36,22.65-0.29,23.93-0.34,25.27-0.36",
    "éi":"23:17.09-0.38",
    "èi":"23:4.09-0.89",
    "ěi":"23:45.99-0.34,47.33-0.41",
    "ēi":"23:26.63-0.41,28.04-0.51,29.55-0.41,30.96-0.35,32.31-0.51",
    "èn":"23:5.98-0.3,7.28-0.3,8.58-0.27,9.85-0.85,11.7-0.3",
    "ēn":"23:33.82-0.4,35.22-0.33,36.54-0.38,37.93-0.37,39.29-0.48",
    "ér":"23:18.47-0.35,19.82-0.47",
    "èr":"23:13-0.39,14.39-0.39",
    "ěr":"23:48.74-0.46",
    "fá":"4:8.59-0.57,10.16-0.66,11.82-0.53,13.35-0.57,14.92-0.56",
    "fà":"4:0-0.56",
    "fǎ":"4:144.4-0.7,146.1-0.57,147.67-0.61,149.28-0.51,150.79-0.52",
    "fā":"4:87.44-0.44,88.88-0.4,90.28-0.43,91.71-0.54,93.25-0.48",
    "fán":"4:16.47-0.76,18.23-0.76,19.99-0.57,21.56-0.61",
    "fàn":"4:1.55-0.4",
    "fǎn":"4:152.31-0.52,153.83-0.57,155.39-0.56,156.94-0.71",
    "fān":"4:94.73-0.54,96.27-0.46,97.73-0.59",
    "fáng":"4:23.17-0.59,24.76-0.69,26.45-0.48,27.93-0.66,29.59-0.62",
    "fàng":"4:2.95-0.37,4.32-0.46,5.78-0.46,7.24-0.35",
    "fǎng":"4:158.65-0.56,160.2-0.56,161.75-0.65",
    "fāng":"4:99.32-0.61,100.93-0.57,102.5-0.45,103.95-0.42,105.37-0.57",
    "féi":"4:45.88-0.6,47.48-0.57,49.05-0.52,50.57-0.4",
    "fèi":"4:31.21-0.52,32.73-0.46,34.19-0.57,35.75-0.51",
    "fěi":"4:123.63-0.57,125.2-0.57,126.77-0.64,128.41-0.59",
    "fēi":"4:106.94-0.42,108.36-0.5,109.86-0.56",
    "fén":"4:51.97-0.4,53.37-0.48,54.85-0.57",
    "fèn":"4:37.26-0.48,38.74-0.51,40.25-0.37",
    "fěn":"4:130-0.61,131.61-0.74",
    "fēn":"4:111.41-0.5,112.91-0.51,114.42-0.6,116.02-0.46",
    "féng":"4:56.41-0.53,57.94-0.62,59.56-0.63,61.19-0.46,62.65-0.64",
    "fèng":"4:41.62-0.47,43.09-0.4,44.49-0.39",
    "fěng":"4:133.35-0.72,135.07-0.64",
    "fēng":"4:117.48-0.62,119.1-0.43,120.53-0.59,122.12-0.51",
    "fó":"4:64.29-0.62,65.91-0.58,67.48-0.69,69.18-0.57,70.73-0.52",
    "fóu":"4:72.26-0.48,73.73-0.6",
    "fǒu":"4:163.4-0.59,164.99-0.71,166.7-0.52,168.22-0.71",
    "fú":"4:81.23-0.51,82.74-0.57,84.31-0.56,85.86-0.58",
    "fù":"4:75.34-0.47,76.81-0.46,78.27-0.53,79.8-0.43",
    "fǔ":"4:169.93-0.93,171.86-0.84,173.7-0.67,175.37-0.59",
    "fū":"4:136.71-0.52,138.23-0.43,139.66-0.44,141.1-0.65,142.75-0.65",
    "gá":"5:115.68-0.47,117.15-0.5",
    "gà":"5:89.83-0.29",
    "gǎ":"5:237.04-0.41,238.45-0.48",
    "gā":"5:160.47-0.34,161.81-0.36",
    "gài":"5:91.11-0.42,92.53-0.34,93.87-0.36,95.23-0.4",
    "gǎi":"5:239.93-0.4,241.33-0.45,242.78-0.39,244.17-0.39,245.56-0.5",
    "gāi":"5:163.17-0.46,164.63-0.47,166.1-0.34,167.44-0.56,168.99-0.4",
    "gàn":"5:96.63-0.37,98-0.46,99.46-0.36,100.82-0.35,102.17-0.4",
    "gǎn":"5:247.06-0.47,248.53-0.91,250.44-0.45",
    "gān":"5:170.39-0.31,171.7-0.39,173.09-0.4,174.49-0.56",
    "gàng":"5:103.57-0.34,104.91-0.38,106.29-0.4,107.69-0.4",
    "gǎng":"5:251.89-0.51,253.4-0.47,254.87-0.47,256.34-0.35",
    "gāng":"5:176.04-0.31,177.35-0.38,178.73-0.4,180.13-0.35,181.48-0.39",
    "gào":"5:109.09-0.32,110.41-0.24,111.65-0.33,112.98-0.35,114.33-0.35",
    "gǎo":"5:257.69-0.41,259.1-0.41,260.51-0.46,261.97-0.44,263.41-0.54",
    "gāo":"5:182.87-0.46,184.33-0.42,185.75-0.5,187.25-0.57,188.82-0.31",
    "gé":"5:133.41-0.47,134.88-0.39,136.28-0.46",
    "gè":"5:118.65-0.5,120.15-0.26,121.41-0.27,122.68-0.24,123.92-0.29",
    "gě":"5:202.99-0.51,204.5-0.52,206.02-0.44",
    "gē":"5:190.13-0.45,191.58-0.41,192.99-0.38,194.37-0.32",
    "gěi":"5:207.46-0.65,209.11-0.57,210.67-0.66",
    "gén":"5:137.74-0.45",
    "gèn":"5:125.2-0.34,126.54-0.34,127.88-0.43",
    "gēn":"5:195.69-0.82,197.51-0.38,198.89-0.3,200.19-0.41",
    "gèng":"5:129.31-0.4,130.71-0.39,132.1-0.32",
    "gěng":"5:212.33-0.62,213.95-0.43,215.38-0.44",
    "gēng":"5:201.6-0.39",
    "gòng":"5:139.19-0.49,140.68-0.36,142.04-0.26",
    "gǒng":"5:264.95-0.61,266.56-0.49,268.05-0.49",
    "gōng":"5:216.82-0.57,218.38-0.35,219.73-0.34,221.07-0.37,222.44-0.33",
    "gòu":"5:143.3-0.31,144.61-0.37,145.97-0.3,147.28-0.3,148.58-0.26",
    "gǒu":"5:269.54-0.44,270.98-0.93,272.91-0.45,274.36-0.51,275.87-0.5",
    "gōu":"5:223.77-0.41,225.18-0.29,226.47-0.34,227.81-0.33,229.14-0.31",
    "gù":"5:149.84-0.34,151.18-0.27,152.45-0.41,153.86-0.27,155.13-0.34",
    "gǔ":"5:277.37-0.39,278.76-0.52",
    "gū":"5:230.45-0.33,231.78-0.33,233.11-0.31,234.42-0.29,235.71-0.33",
    "guà":"5:0-0.33,1.33-0.4,2.73-0.36,4.09-0.46",
    "guǎ":"5:65.48-0.57",
    "guā":"5:33.68-0.37,35.04-0.37,36.42-0.48",
    "guài":"5:5.55-0.29,6.83-0.44,8.27-0.51,9.77-0.29",
    "guǎi":"5:67.05-0.54,68.59-0.43,70.02-0.56",
    "guāi":"5:37.9-0.38,39.28-0.46,40.74-0.37,42.11-0.41,43.52-0.39",
    "guàn":"5:11.06-0.35,12.41-0.34,13.75-0.4,15.15-0.5",
    "guǎn":"5:71.56-0.45,73.02-0.53,74.55-0.54,76.09-0.54",
    "guān":"5:44.91-0.35,46.26-0.65,47.91-0.51,49.42-0.5",
    "guàng":"5:16.64-0.45,18.1-0.35,19.45-0.46",
    "guǎng":"5:77.63-0.48,79.11-0.6,80.71-0.51",
    "guāng":"5:50.92-0.38,52.3-0.47,53.77-0.5,55.27-0.5,56.77-0.36",
    "guì":"5:20.91-0.45,22.36-0.4",
    "guǐ":"5:82.22-0.47",
    "guī":"5:58.13-0.49,59.62-0.47,61.09-0.5",
    "gùn":"5:156.47-0.34,157.81-0.33,159.14-0.33",
    "gǔn":"5:280.28-0.51,281.79-0.56,283.34-0.48,284.82-0.65",
    "guó":"5:29.29-0.53,30.82-0.5,32.32-0.36",
    "guò":"5:23.76-0.35,25.11-0.45,26.56-0.35,27.91-0.38",
    "guǒ":"5:83.69-0.57,85.25-0.58,86.83-0.54,88.37-0.46",
    "guō":"5:62.59-0.44,64.03-0.45",
    "hā":"6:213.7-0.41,215.11-0.32,216.43-0.4,217.83-0.49,219.32-0.46",
    "hái":"6:117.77-0.51,119.28-0.66,120.94-0.52,122.46-0.56,124.01-0.66",
    "hài":"6:92.13-0.54,93.67-0.41,95.08-0.54,96.62-0.4,98.02-0.44",
    "hǎi":"6:289.93-0.57,291.5-0.75,293.25-0.62",
    "hán":"6:125.67-0.73,127.4-0.73,129.13-0.57,130.7-1.66,133.36-0.72",
    "hàn":"6:99.46-0.74,101.2-0.36,102.56-0.5,104.06-0.61,105.67-0.54",
    "hǎn":"6:294.87-0.62,296.49-0.71",
    "hān":"6:220.78-0.62,222.4-0.5,223.9-0.57,225.46-0.59,227.05-0.54",
    "háng":"6:135.08-0.66,136.74-0.57,138.3-0.52",
    "hàng":"6:107.21-0.5,108.71-0.43,110.14-0.48,111.62-0.57",
    "hāng":"6:228.59-0.49,230.08-0.5,231.58-0.92,233.5-0.51,235.01-0.47",
    "háo":"6:139.82-0.5,141.32-0.92,143.24-0.57,144.8-0.58,146.38-0.86",
    "hào":"6:113.18-0.45,114.63-0.61,116.24-0.53",
    "hǎo":"6:298.2-0.74,299.94-0.62,301.56-0.89,303.45-0.64",
    "hāo":"6:236.48-0.74,238.22-0.56,239.77-0.48,241.25-0.46,242.71-0.5",
    "hé":"6:158.76-0.56,160.31-0.53,161.84-0.5,163.34-0.47,164.81-0.56",
    "hè":"6:148.24-0.54,149.78-0.43,151.21-0.52",
    "hē":"6:244.21-0.57,245.77-0.91,247.68-0.42",
    "hēi":"6:249.1-0.52,250.62-0.61,252.23-0.4,253.63-0.42",
    "hén":"6:166.36-0.5,167.86-0.56,169.41-0.5,170.91-0.57",
    "hèn":"6:152.73-0.43,154.16-0.56,155.71-0.51,157.22-0.54",
    "hěn":"6:261.04-0.59,262.63-0.65,264.28-1.32,266.6-1.01",
    "héng":"6:172.47-0.47",
    "hēng":"6:255.05-0.51,256.56-0.41,257.97-0.58,259.55-0.49",
    "hóng":"6:184.43-0.54,185.97-0.5,187.47-0.54,189.01-0.56,190.56-0.66",
    "hòng":"6:173.94-0.49,175.43-0.53",
    "hǒng":"6:305.08-0.62,306.7-0.81,308.52-0.63,310.14-0.66",
    "hōng":"6:268.61-0.46,270.07-0.46,271.52-0.5,273.02-0.45",
    "hóu":"6:192.22-0.53,193.75-0.57,195.31-0.57,196.87-0.54",
    "hòu":"6:176.96-0.46,178.42-0.49,179.91-0.47,181.38-0.51,182.89-0.54",
    "hǒu":"6:311.81-0.59,313.39-0.57,314.97-0.61,316.58-0.64,318.22-0.74",
    "hōu":"6:274.48-0.44,275.92-0.54,277.45-0.47,278.93-0.58",
    "hú":"6:205.76-0.56,207.31-0.47,208.78-0.69",
    "hù":"6:198.41-0.48,199.89-0.47,201.36-0.54",
    "hǔ":"6:319.95-0.79,321.75-0.73,323.48-0.54,325.02-0.73",
    "hū":"6:280.51-0.57,282.07-0.64,283.7-0.4",
    "huá":"6:11.75-0.47,13.22-0.52,14.74-0.56,16.29-0.48",
    "huà":"6:0-0.4,1.4-0.41,2.81-0.54,4.34-0.51",
    "huā":"6:51.99-0.46,53.45-0.43,54.88-0.47,56.35-0.39",
    "huái":"6:17.77-0.46,19.23-0.72,20.95-0.47,22.42-0.61",
    "huài":"6:5.86-0.46,7.32-0.4",
    "huán":"6:24.03-0.89,25.92-0.58,27.5-0.56",
    "huàn":"6:8.72-0.49,10.21-0.54",
    "huǎn":"6:75.65-0.57,77.21-0.57,78.78-0.6",
    "huān":"6:57.74-0.44,59.18-0.52,60.7-0.59",
    "huáng":"6:29.05-0.53,30.58-0.49",
    "huǎng":"6:80.38-0.65,82.03-0.72,83.75-2.44",
    "huāng":"6:62.29-0.47,63.76-0.44,65.2-0.48,66.68-0.53,68.21-0.42",
    "huí":"6:36.47-0.5,37.97-0.82,39.79-0.56",
    "huì":"6:32.07-0.49,33.56-0.52,35.08-0.39",
    "huǐ":"6:87.18-0.81",
    "huī":"6:69.63-0.51",
    "hún":"6:210.47-0.52,211.99-0.71",
    "hùn":"6:202.9-0.41,204.31-0.45",
    "hūn":"6:285.11-0.53,286.64-0.73,288.37-0.57",
    "huó":"6:45.48-0.58,47.06-0.53,48.59-0.64,50.23-0.76",
    "huò":"6:41.34-0.39,42.73-0.35,44.08-0.4",
    "huǒ":"6:88.99-0.59,90.58-0.56",
    "huō":"6:71.14-0.52,72.66-0.44,74.1-0.56",
    "jí":"7:168.84-0.62,170.46-0.59,172.05-0.62,173.67-0.4,175.07-0.41",
    "jì":"7:152.56-0.35,153.91-0.36,155.27-0.34,156.61-0.37",
    "jǐ":"7:212.15-0.53,213.68-0.48,215.16-0.49,216.65-0.54",
    "jī":"7:189.17-0.77,190.94-0.66,192.6-0.35,193.95-0.43",
    "jiá":"7:19.24-0.4,20.64-0.48,22.12-0.4",
    "jià":"7:0-0.37,1.37-0.38,2.75-0.37,4.12-0.32",
    "jiǎ":"7:90.84-0.48,92.32-0.5",
    "jiā":"7:49.02-0.47,50.49-0.34,51.83-0.36,53.19-0.36,54.55-0.37",
    "jiàn":"7:5.44-0.35,6.79-0.4,8.19-0.36",
    "jiǎn":"7:93.82-0.46,95.28-0.79",
    "jiān":"7:55.92-0.39,57.31-0.45,58.76-0.51",
    "jiàng":"7:9.55-0.31,10.86-0.41,12.27-0.53,13.8-0.39,15.19-0.35",
    "jiǎng":"7:97.07-0.53,98.6-0.49,100.09-0.46",
    "jiāng":"7:60.27-0.38,61.65-0.6,63.25-0.46,64.71-0.4",
    "jiáo":"7:23.52-0.53,25.05-0.45,26.5-0.42,27.92-0.47",
    "jiào":"7:16.54-0.35,17.89-0.35",
    "jiǎo":"7:101.55-0.49,103.04-0.46",
    "jiāo":"7:66.11-0.43,67.54-0.35,68.89-0.38,70.27-0.44,71.71-0.41",
    "jié":"7:34.84-0.58,36.42-0.44,37.86-0.54",
    "jiè":"7:29.39-0.35,30.74-0.37,32.11-0.36,33.47-0.37",
    "jiě":"7:78.72-0.5,80.22-0.43,81.65-0.51,83.16-0.74,84.9-0.63",
    "jiē":"7:73.12-0.34,74.46-0.39,75.85-0.38,77.23-0.49",
    "jìn":"7:157.98-0.32,159.3-0.41,160.71-0.38,162.09-0.34",
    "jǐn":"7:218.19-0.56,219.74-0.52,221.26-0.59",
    "jīn":"7:195.38-0.39,196.77-0.39,198.16-0.43,199.59-0.44",
    "jìng":"7:163.43-0.39,164.82-0.31,166.13-0.37,167.5-0.34",
    "jǐng":"7:222.85-0.52,224.37-0.57,225.93-0.43,227.36-0.47,228.83-0.51",
    "jīng":"7:201.03-0.36,202.39-0.39,203.78-0.46",
    "jiǒng":"7:104.5-0.43,105.93-0.56,107.48-0.5,108.98-0.65",
    "jiōng":"7:86.53-0.5",
    "jiú":"7:43.54-0.78,45.32-0.79,47.11-0.91",
    "jiù":"7:39.4-0.45,40.85-0.35,42.2-0.34",
    "jiǔ":"7:110.63-0.5,112.13-0.77,113.9-0.57",
    "jiū":"7:88.03-0.39,89.42-0.42",
    "jú":"7:184.8-0.48,186.28-0.47,187.75-0.42",
    "jù":"7:176.48-0.41,177.89-0.3",
    "jǔ":"7:230.34-0.46,231.8-0.47",
    "jū":"7:205.24-0.42,206.66-0.38,208.04-0.34,209.38-0.36",
    "juàn":"7:115.46-0.39,116.85-0.52,118.37-0.41,119.78-0.42",
    "juǎn":"7:148.16-0.4,149.56-0.47,151.03-0.53",
    "juān":"7:128.29-0.44,129.73-0.34,131.07-0.5,132.57-0.45",
    "jué":"7:121.2-0.41,122.61-0.45,124.06-0.37,125.43-0.43,126.86-0.43",
    "juě":"7:140.85-0.43,142.28-0.47,143.75-0.47,145.22-0.47,146.69-0.47",
    "juē":"7:134.02-0.39,135.41-0.32,136.72-0.37,138.1-0.35,139.44-0.4",
    "jùn":"7:179.19-0.36,180.55-0.4,181.95-0.38,183.33-0.47",
    "jūn":"7:210.74-0.41",
    "kǎ":"8:244.85-0.91,246.76-0.91,248.67-0.4,250.07-0.91",
    "kā":"8:162.32-0.38,163.7-0.45,165.15-0.43,166.58-0.32,167.9-0.38",
    "kài":"8:92.95-0.4,94.35-0.37,95.72-0.39,97.11-0.47,98.58-0.34",
    "kǎi":"8:251.98-0.47,253.45-0.56,255-0.47",
    "kāi":"8:169.28-0.44,170.72-0.4,172.12-0.45,173.57-0.65",
    "kàn":"8:99.92-0.48,101.4-0.5,102.9-0.35,104.25-0.33,105.58-0.5",
    "kǎn":"8:256.47-0.56,258.02-0.72,259.74-1.11,261.84-0.54",
    "kān":"8:175.22-0.45,176.67-0.46,178.13-0.46,179.59-0.48,181.07-0.47",
    "káng":"8:121.3-0.5,122.8-0.61,124.41-0.56,125.96-0.72,127.68-0.57",
    "kàng":"8:107.08-0.47,108.55-0.36,109.91-0.4,111.31-0.4,112.71-0.52",
    "kāng":"8:182.54-0.44,183.98-0.53,185.51-0.39,186.9-0.5,188.4-0.43",
    "kào":"8:114.23-0.4,115.63-0.42,117.05-0.47,118.52-0.38,119.9-0.4",
    "kǎo":"8:263.38-0.41,264.79-0.66,266.45-0.53,267.98-0.71,269.69-0.56",
    "kāo":"8:189.83-0.64,191.47-0.56,193.02-0.49,194.51-0.47",
    "ké":"8:136.32-0.43,137.75-0.41,139.16-0.61",
    "kè":"8:129.24-0.39,130.63-0.4,132.03-0.39,133.41-0.49",
    "kě":"8:205.21-0.53,206.74-0.56,208.29-0.49,209.78-0.64",
    "kē":"8:195.98-1.01,197.99-0.44,199.43-0.4",
    "kèn":"8:134.91-0.41",
    "kěn":"8:211.42-0.64,213.06-0.66,214.72-0.49,216.21-0.74",
    "kēng":"8:200.83-0.56,202.38-0.43,203.81-0.4",
    "kòng":"8:140.77-0.37,142.14-0.34,143.48-0.46,144.94-0.36,146.3-0.57",
    "kǒng":"8:271.24-0.53,272.77-0.45,274.22-0.56,275.77-0.57,277.33-0.52",
    "kōng":"8:217.95-1.01,219.96-0.46,221.42-1.01,223.43-0.2,224.63-0.5",
    "kòu":"8:147.87-0.53,149.4-0.39,150.79-0.39,152.18-0.49,153.67-0.46",
    "kǒu":"8:278.85-0.5,280.35-0.53,281.88-0.56,283.43-0.57,284.99-0.52",
    "kōu":"8:226.13-0.44,227.57-0.52,229.09-0.38,230.47-0.47,231.94-0.43",
    "kù":"8:155.13-0.45,156.58-0.47,158.05-0.4",
    "kǔ":"8:286.51-0.58,288.09-0.6,289.69-0.61,291.3-0.64,292.94-0.59",
    "kū":"8:233.37-0.56,234.92-0.41,236.33-0.43,237.76-0.32,239.08-0.38",
    "kuà":"8:0-0.38,1.38-0.57,2.95-0.39,4.34-0.47,5.81-0.38",
    "kuǎ":"8:79.04-0.62",
    "kuā":"8:50.56-0.51,52.07-0.44,53.51-0.49,55-0.54,56.54-0.54",
    "kuài":"8:7.19-0.31,8.5-0.35,9.85-0.35,11.2-0.46",
    "kuǎi":"8:80.66-0.91,82.57-0.57",
    "kuǎn":"8:84.14-0.92,86.06-0.73",
    "kuān":"8:58.08-0.41,59.49-0.56,61.04-0.46,62.5-0.52",
    "kuáng":"8:19.85-0.51,21.36-0.65,23.01-0.56,24.56-0.63,26.19-0.5",
    "kuàng":"8:12.66-0.46,14.12-0.46,15.58-0.41,16.99-0.42,18.41-0.44",
    "kuāng":"8:64.02-0.47,65.48-0.52,67.01-0.53,68.54-0.57,70.09-0.5",
    "kuí":"8:34.89-0.48,36.37-0.49,37.86-0.91,39.77-0.67,41.44-0.68",
    "kuì":"8:27.69-0.41,29.1-0.39,30.49-0.4,31.89-0.54,33.43-0.46",
    "kuǐ":"8:87.79-0.79,89.58-0.89,91.47-0.48",
    "kuī":"8:71.59-0.56,73.15-0.51,74.66-0.46,76.12-0.5,77.62-0.42",
    "kùn":"8:159.45-0.46,160.91-0.41",
    "kǔn":"8:294.53-0.5",
    "kūn":"8:240.46-0.41,241.87-0.47,243.34-0.51",
    "kuò":"8:43.12-0.73,44.85-0.32,46.17-0.48,47.65-0.41,49.06-0.5",
    "lá":"9:133.66-0.44",
    "là":"9:111.26-0.38",
    "lǎ":"9:310.35-0.52",
    "lā":"9:258.36-0.7,260.06-0.5",
    "lái":"9:135.1-0.57,136.66-0.53,138.19-0.36,139.56-0.38",
    "lài":"9:112.64-0.44,114.08-0.36,115.44-0.36,116.8-0.32",
    "lán":"9:140.94-0.45,142.38-0.41,143.8-0.46",
    "làn":"9:118.12-0.34,119.46-0.36,120.82-0.52,122.34-0.49,123.83-0.37",
    "lǎn":"9:311.87-0.47,313.33-0.65,314.99-0.54",
    "láng":"9:145.26-0.56,146.81-0.39,148.19-0.41,149.61-0.57",
    "làng":"9:125.2-0.35,126.55-0.34,127.89-0.51,129.4-0.47,130.87-0.4",
    "lǎng":"9:316.52-0.57,318.08-0.56,319.64-0.53",
    "lāng":"9:261.56-0.51,263.07-0.35",
    "láo":"9:151.16-0.43,152.6-0.54,154.13-0.5,155.63-0.49",
    "lào":"9:132.27-0.39",
    "lǎo":"9:321.17-0.48,322.64-0.53,324.18-0.52,325.7-0.52",
    "lāo":"9:264.42-0.41,265.83-0.53,267.36-0.46,268.82-0.37",
    "lè":"9:157.13-0.39,158.52-0.4,159.91-0.35,161.27-0.37",
    "léi":"9:176.14-0.49,177.63-0.61,179.24-0.44,180.68-0.46",
    "lèi":"9:162.63-1.12,164.75-0.5,166.25-0.44,167.69-0.34,169.03-0.34",
    "lěi":"9:270.19-0.45",
    "léng":"9:182.14-0.46,183.6-0.49,185.09-0.42,186.51-0.48",
    "lèng":"9:170.37-0.47,171.84-0.39,173.23-0.42,174.65-0.49",
    "lěng":"9:271.64-0.51,273.14-0.44,274.58-0.92",
    "lí":"9:198.94-0.57,200.5-0.41,201.91-0.95,203.86-0.5,205.36-0.48",
    "lì":"9:187.99-0.41,189.4-0.4,190.8-0.36",
    "lǐ":"9:327.22-0.45,328.67-0.51,330.18-0.48,331.66-0.5",
    "lī":"9:276.51-0.45,277.95-0.34,279.3-0.56,280.85-0.35,282.2-0.54",
    "liǎ":"9:59.95-0.47,61.42-0.65",
    "lián":"9:14.38-0.46,15.84-0.52,17.36-0.74,19.1-0.46",
    "liàn":"9:0-0.48,1.48-0.3,2.78-0.45,4.23-0.43",
    "liǎn":"9:63.07-0.58,64.65-0.46,66.11-0.58",
    "liáng":"9:20.56-0.59,22.15-0.61,23.76-0.48,25.24-0.5,26.74-0.52",
    "liàng":"9:5.66-0.44,7.1-0.5,8.6-0.43",
    "liǎng":"9:67.69-0.56,69.23-0.5,70.73-0.45",
    "liáo":"9:28.26-0.54,29.8-0.52,31.32-0.43,32.75-1.01",
    "liào":"9:10.03-0.38,11.41-0.44,12.85-0.53",
    "liǎo":"9:72.19-0.62,73.81-0.67",
    "liè":"9:34.76-0.37,36.13-0.35,37.47-0.44,38.92-0.56",
    "liē":"9:52.86-0.45,54.31-0.45",
    "lín":"9:206.84-0.49,208.33-0.43,209.76-0.56",
    "lìn":"9:192.16-0.34,193.5-0.35,194.85-0.26",
    "lǐn":"9:333.16-0.75",
    "līn":"9:283.74-0.39,285.13-0.44,286.57-0.44,288.01-0.53",
    "líng":"9:211.31-0.47,212.78-0.6,214.38-0.63",
    "lìng":"9:196.11-0.39,197.5-0.44",
    "lǐng":"9:334.91-0.91",
    "līng":"9:289.54-0.4",
    "liú":"9:44.55-0.46,46.01-0.54,47.55-0.65,49.2-1.15,51.35-0.51",
    "liù":"9:40.47-0.37,41.84-0.35,43.19-0.36",
    "liǔ":"9:75.48-0.48,76.95-0.57,78.53-0.67,80.2-0.46",
    "liū":"9:55.76-0.41,57.17-0.37,58.54-0.41",
    "lóng":"9:221.59-0.57,223.15-0.48,224.63-0.4,226.03-0.51,227.54-0.42",
    "lǒng":"9:336.82-0.47,338.29-0.49,339.78-0.64,341.42-0.41",
    "lōng":"9:290.94-0.46,292.39-0.5",
    "lóu":"9:228.96-0.58,230.54-0.35,231.89-0.66,233.55-0.45,235-0.52",
    "lòu":"9:216.01-0.37,217.38-0.43,218.81-0.43,220.24-0.35",
    "lǒu":"9:342.83-0.38,344.21-0.61,345.82-0.42",
    "lōu":"9:293.89-0.57,295.45-0.53,296.99-0.86",
    "lú":"9:246.61-0.44,248.05-0.6,249.65-0.46",
    "lù":"9:236.52-0.36,237.88-0.44,239.32-0.37",
    "lǔ":"9:347.24-0.44,348.68-0.47,350.15-0.42",
    "lǘ":"9:351.57-0.47,353.04-0.43,354.47-0.5,355.97-0.49,357.46-0.54",
    "lǜ":"9:366.99-0.36,368.35-0.46,369.81-0.32,371.13-0.34",
    "lǚ":"9:359-0.65,360.65-0.69,362.34-0.59,363.93-0.57,365.49-0.5",
    "lū":"9:298.85-0.48,300.33-0.39,301.72-0.43,303.14-0.44",
    "luán":"9:84.57-0.5,86.07-0.53,87.6-0.51,89.11-0.52",
    "luàn":"9:81.66-0.45,83.11-0.46",
    "luǎn":"9:103.56-0.47,105.03-0.46,106.49-0.5",
    "lüè":"9:252.63-0.35,253.98-0.51,255.49-0.51,257-0.36",
    "lún":"9:251.11-0.52",
    "lùn":"9:240.69-0.57,242.25-0.36,243.61-0.51,245.12-0.49",
    "lūn":"9:304.58-0.5,306.08-0.45,307.54-0.41,308.95-0.4",
    "luó":"9:94.85-0.45,96.3-0.39,97.69-0.44",
    "luò":"9:90.63-0.45,92.08-0.43,93.51-0.34",
    "luǒ":"9:107.99-0.71,109.7-0.57",
    "luō":"9:99.13-0.5,100.63-0.51,102.14-0.42",
    "má":"10:64.73-0.36",
    "mà":"10:41.77-0.33,43.1-0.44,44.54-0.49,46.03-0.53",
    "mǎ":"10:246.33-0.56,247.88-0.52,249.4-0.49",
    "mā":"10:186.28-0.54,187.82-0.53,189.35-0.46,190.81-0.57",
    "mái":"10:66.09-0.57,67.67-0.5,69.17-0.54,70.7-0.46,72.17-0.45",
    "mài":"10:47.56-0.47,49.03-0.34,50.37-0.33,51.7-0.41,53.11-0.36",
    "mǎi":"10:250.89-0.65,252.54-0.57,254.11-0.52,255.63-0.84,257.47-0.77",
    "mán":"10:73.62-0.52,75.14-0.51,76.65-0.57,78.2-0.72,79.93-0.43",
    "màn":"10:54.47-0.54,56.01-0.44,57.45-0.5",
    "mǎn":"10:259.24-0.71,260.95-0.56,262.5-0.5",
    "mān":"10:192.38-0.57,193.95-0.46,195.41-0.68,197.09-0.41",
    "máng":"10:81.36-0.5,82.86-0.51,84.37-0.41,85.78-0.62",
    "mǎng":"10:264-3.29,268.29-0.49,269.78-0.52,271.3-0.66",
    "māng":"10:198.5-0.5,200-0.58,201.58-0.5",
    "máo":"10:87.4-0.64,89.04-0.64,90.68-0.57,92.24-0.66,93.9-0.73",
    "mào":"10:58.95-0.35,60.3-0.42,61.72-0.56,63.27-0.47",
    "mǎo":"10:272.96-0.47,274.43-0.6,276.03-0.5",
    "māo":"10:203.08-0.64,204.72-0.4,206.12-0.43,207.55-0.4",
    "méi":"10:107.41-0.44,108.85-0.51,110.36-0.57,111.92-0.48",
    "mèi":"10:95.63-0.46,97.09-0.35",
    "měi":"10:215.08-0.65,216.73-0.61,218.34-0.63,219.97-1.16",
    "mén":"10:113.4-0.54,114.94-0.51,116.45-0.45,117.9-0.46,119.36-0.57",
    "mèn":"10:98.44-0.41",
    "mēn":"10:208.95-0.58,210.53-0.5,212.03-0.51",
    "méng":"10:120.92-0.91,122.83-0.57,124.39-0.59,125.98-0.51",
    "mèng":"10:99.85-0.44,101.29-0.46,102.75-0.35,104.1-0.65,105.75-0.66",
    "měng":"10:222.13-0.68,223.81-0.61,225.42-0.51",
    "mēng":"10:213.54-0.54",
    "mí":"10:139.05-0.38,140.43-0.54",
    "mì":"10:127.49-0.39,128.88-0.42,130.3-0.41",
    "mǐ":"10:277.53-0.62,279.15-0.84,280.99-1.46,283.45-0.64",
    "mī":"10:226.93-0.51,228.44-0.36,229.8-0.54",
    "mián":"10:10.89-0.76,12.65-0.58,14.23-0.62",
    "miàn":"10:0-0.56,1.55-0.5,3.05-0.54,4.59-0.5",
    "miǎn":"10:32.6-1.11,34.7-0.9,36.6-0.57,38.17-0.84",
    "miáo":"10:15.85-0.49,17.34-0.68,19.02-0.62,20.64-0.43",
    "miào":"10:6.09-0.58,7.67-0.73,9.4-0.49",
    "miǎo":"10:40.01-0.76",
    "miāo":"10:26.3-0.61,27.91-0.72,29.63-0.51",
    "miè":"10:22.07-0.49,23.56-0.34,24.9-0.4",
    "miē":"10:31.14-0.46",
    "mín":"10:141.97-0.51,143.47-0.77,145.25-0.49,146.74-0.59",
    "mǐn":"10:285.09-0.74,286.83-0.69",
    "míng":"10:148.33-0.77,150.1-0.69,151.79-0.56,153.34-0.64,154.98-0.57",
    "mìng":"10:131.71-0.5,133.21-0.72,134.93-0.36,136.29-0.4,137.69-0.36",
    "mǐng":"10:288.52-0.57,290.08-0.56,291.63-0.78,293.41-0.57",
    "mó":"10:162.47-0.54,164.01-0.4,165.41-0.51",
    "mò":"10:156.54-0.4,157.94-0.51,159.45-0.47,160.92-0.56",
    "mǒ":"10:294.97-0.66,296.63-0.56,298.18-0.56,299.73-0.48,301.21-0.71",
    "mō":"10:231.34-0.57,232.91-0.42,234.33-0.49,235.82-0.42,237.24-0.53",
    "móu":"10:166.92-0.48,168.4-0.56,169.95-0.54,171.49-0.46,172.95-0.46",
    "mǒu":"10:302.92-0.49,304.41-0.56,305.96-0.7,307.66-0.57",
    "mōu":"10:238.77-0.56,240.32-0.52,241.84-0.64,243.48-0.4,244.88-0.45",
    "mú":"10:181.51-0.59,183.1-0.7,184.8-0.48",
    "mù":"10:174.41-0.33,175.74-0.5,177.24-0.32,178.56-0.4,179.96-0.56",
    "mǔ":"10:309.23-0.62,310.85-0.69",
    "ná":"11:101.08-0.51,102.59-0.58,104.17-0.59,105.76-0.65,107.41-0.74",
    "nà":"11:71.58-0.57,73.15-0.41,74.56-0.49,76.05-0.42,77.47-0.46",
    "nǎ":"11:226.35-0.41,227.76-0.51,229.27-0.67,230.94-0.58,232.52-0.95",
    "nài":"11:78.93-0.45,80.38-0.44,81.81-0.43,83.25-0.5,84.75-0.52",
    "nǎi":"11:234.47-0.54,236.01-0.71",
    "nán":"11:109.15-0.96,111.11-0.47,112.58-0.48",
    "nǎn":"11:237.72-0.51,239.23-0.58,240.81-0.57,242.38-0.67,244.05-0.56",
    "nān":"11:201.62-0.39,203.01-0.49",
    "náng":"11:114.06-0.65,115.71-0.63",
    "nàng":"11:86.27-0.49,87.76-0.43,89.19-0.66,90.85-0.41,92.26-0.46",
    "nǎng":"11:245.6-0.65,247.25-0.49,248.74-0.56,250.29-0.53,251.82-0.66",
    "nāng":"11:204.5-0.59,206.09-0.47,207.56-0.5,209.06-0.5",
    "náo":"11:117.34-0.57,118.9-0.66,120.56-0.44,122-0.49,123.49-0.57",
    "nào":"11:93.72-0.38,95.1-0.51,96.61-0.51,98.12-0.41,99.53-0.56",
    "nǎo":"11:253.48-0.54,255.02-0.89,256.91-0.78,258.69-0.5",
    "nāo":"11:210.56-0.43,211.99-0.54,213.53-0.57,215.09-0.47,216.56-0.45",
    "nè":"11:125.06-0.54,126.6-0.45,128.05-0.5,129.55-0.47",
    "nèi":"11:131.02-0.33,132.35-0.56,133.9-0.39,135.29-0.41",
    "něi":"11:218.01-0.59,219.6-0.67,221.27-0.58,222.85-0.99",
    "nèn":"11:136.69-0.39,138.09-0.92,140.01-0.39,141.4-0.54,142.94-0.47",
    "néng":"11:144.41-0.5,145.91-0.56,147.46-0.63,149.09-0.48,150.57-0.54",
    "ní":"11:162.47-0.72,164.2-0.51,165.71-0.51",
    "nì":"11:152.11-0.47,153.58-0.46,155.04-0.51,156.55-0.52,158.07-0.36",
    "nǐ":"11:260.19-0.6,261.79-1.18,263.97-0.51",
    "nī":"11:224.84-0.51",
    "nián":"11:11.64-0.72,13.36-0.57,14.93-0.46,16.39-0.49",
    "niàn":"11:0-0.51,1.51-0.47,2.98-0.51",
    "niǎn":"11:45.18-0.66,46.84-0.48,48.32-0.76",
    "niān":"11:32.61-0.63,34.24-0.57",
    "niáng":"11:17.88-0.47,19.35-1.15",
    "niàng":"11:4.49-0.37,5.86-0.35,7.21-0.49",
    "niào":"11:8.69-0.45,10.15-0.49",
    "niǎo":"11:50.08-0.92,52-1.06,54.06-0.74",
    "nié":"11:25.94-0.54",
    "niè":"11:21.5-0.44,22.94-0.5,24.44-0.5",
    "niē":"11:35.8-0.5,37.3-0.4,38.7-0.57",
    "níng":"11:167.22-0.57,168.79-0.57",
    "nìng":"11:159.43-0.54,160.97-0.51",
    "nǐng":"11:265.48-0.66,267.14-0.57",
    "niú":"11:27.48-0.64,29.12-0.95,31.07-0.54",
    "niǔ":"11:55.8-0.57,57.37-0.92",
    "niū":"11:40.27-0.49,41.76-0.82,43.58-0.6",
    "nóng":"11:182.11-0.57,183.67-0.47,185.14-0.65,186.79-0.75,188.54-0.68",
    "nòng":"11:170.36-0.51,171.87-0.4,173.27-0.37,174.64-0.36",
    "nòu":"11:176-0.66,177.66-0.53,179.19-0.54,180.73-0.38",
    "nú":"11:191.71-0.58",
    "nù":"11:190.22-0.49",
    "nǔ":"11:268.7-0.62",
    "nǜ":"11:277.26-0.51,278.77-0.39",
    "nǚ":"11:270.32-0.57,271.88-0.79,273.67-0.66,275.33-0.93",
    "nuǎn":"11:69.83-0.75",
    "nüè":"11:193.29-0.8,195.09-1.06,197.15-0.34,198.49-0.57,200.05-0.57",
    "nuó":"11:63.42-0.64,65.06-0.47,66.53-0.57,68.09-0.73",
    "nuò":"11:59.29-0.37,60.66-0.39,62.05-0.37",
    "ò":"24:0-0.5,1.5-0.42",
    "ō":"24:6.91-0.37",
    "òu":"24:2.92-0.36,4.28-0.31,5.59-0.32",
    "ǒu":"24:9.74-0.57",
    "ōu":"24:8.27-0.46",
    "pá":"12:82.54-0.45,83.99-0.46,85.45-0.54,86.99-0.57",
    "pà":"12:52.8-0.49,54.29-0.34,55.63-0.38",
    "pā":"12:197.09-0.46,198.55-0.34,199.89-0.45,201.34-0.37",
    "pái":"12:88.55-0.53,90.08-0.63,91.71-0.51",
    "pài":"12:57.01-0.49,58.5-0.44,59.94-0.32,61.26-0.54",
    "pǎi":"12:278.33-0.51,279.84-0.42,281.26-0.79,283.05-0.58,284.63-0.65",
    "pāi":"12:202.71-0.39,204.1-0.34,205.44-0.39,206.83-0.39,208.22-0.59",
    "pán":"12:93.22-0.5,94.72-0.49,96.21-0.54,97.75-0.53",
    "pàn":"12:62.8-0.5,64.3-0.5,65.8-0.41,67.21-0.44",
    "pān":"12:209.81-0.44,211.25-0.49,212.74-0.42,214.16-0.5,215.66-0.49",
    "páng":"12:99.28-0.58,100.86-0.7,102.56-0.6,104.16-0.56,105.71-0.56",
    "pàng":"12:68.65-0.44,70.09-0.35,71.44-0.35,72.79-0.38,74.17-0.47",
    "pǎng":"12:286.28-0.56,287.83-0.56,289.38-0.5",
    "pāng":"12:217.15-0.4,218.55-0.46,220.01-0.41,221.42-0.47",
    "páo":"12:107.26-0.49,108.75-0.66,110.41-0.52,111.93-0.54,113.47-0.48",
    "pào":"12:75.64-0.35,76.98-0.4,78.39-0.38,79.77-0.33,81.09-0.44",
    "pǎo":"12:290.88-0.65,292.53-0.57,294.1-0.57,295.66-0.64,297.3-0.65",
    "pāo":"12:222.89-0.49,224.38-0.49,225.87-0.44,227.31-0.33,228.64-0.43",
    "péi":"12:128.86-0.5,130.36-0.49,131.85-0.44,133.29-0.48,134.77-0.52",
    "pèi":"12:114.95-0.3,116.25-0.3,117.55-0.38,118.93-0.56,120.48-0.33",
    "pēi":"12:230.07-0.5,231.57-0.54,233.11-0.45",
    "pén":"12:136.29-0.57,137.85-0.39,139.24-0.51,140.75-0.32,142.07-0.49",
    "pēn":"12:234.56-0.49,236.05-0.33,237.38-0.34,238.72-0.47,240.19-0.49",
    "péng":"12:143.56-0.52,145.08-0.52",
    "pèng":"12:121.81-0.37,123.18-0.38,124.56-0.47,126.03-0.39,127.42-0.44",
    "pěng":"12:246.27-0.62,247.89-0.53,249.42-0.51,250.93-0.56",
    "pēng":"12:241.68-0.38,243.06-0.61,244.67-0.6",
    "pí":"12:156.54-0.51,158.05-0.48,159.53-0.99",
    "pì":"12:146.6-0.34,147.94-0.44,149.38-0.5",
    "pǐ":"12:298.95-0.63,300.58-0.58",
    "pī":"12:252.48-0.37,253.85-0.39,255.24-0.5,256.74-0.45",
    "pián":"12:8.61-0.6,10.21-0.73,11.94-0.63",
    "piàn":"12:0-0.46,1.46-0.4,2.86-0.4",
    "piǎn":"12:37.77-0.53,39.3-0.67,40.97-0.6,42.57-0.96,44.53-2.5",
    "piān":"12:21.19-0.56,22.74-0.5,24.24-0.5,25.74-0.51",
    "piáo":"12:13.57-0.61,15.18-0.45,16.63-0.52,18.14-0.57,19.71-0.48",
    "piào":"12:4.26-0.49,5.75-0.45,7.2-0.41",
    "piǎo":"12:48.02-0.58,49.6-0.58,51.18-0.62",
    "piāo":"12:27.25-0.44,28.69-0.43,30.12-0.49",
    "piě":"12:33.09-0.52,34.61-0.52,36.13-0.64",
    "piē":"12:31.61-0.48",
    "pín":"12:161.52-0.57,163.09-0.48",
    "pìn":"12:150.88-0.39,152.27-0.44,153.71-0.44,155.15-0.39",
    "pǐn":"12:302.16-0.48,303.64-0.74,305.38-0.54",
    "pīn":"12:258.19-0.53,259.72-0.44,261.16-0.39",
    "píng":"12:164.57-0.62,166.19-0.45,167.64-0.58",
    "pīng":"12:262.55-0.48,264.02-0.63,265.66-0.36",
    "pó":"12:176.38-0.45,177.83-0.49,179.32-0.86,181.18-0.46",
    "pò":"12:169.22-0.37,170.59-0.53,172.12-0.47,173.59-0.35,174.94-0.44",
    "pǒ":"12:306.92-0.48,308.4-0.47,309.87-0.51,311.38-0.45",
    "pō":"12:267.02-0.47,268.49-0.41",
    "póu":"12:182.64-0.49,184.13-0.56,185.68-0.56,187.23-0.42",
    "pōu":"12:269.9-0.44",
    "pú":"12:192.68-0.46,194.14-0.5,195.64-0.45",
    "pù":"12:188.65-0.34,189.99-0.32,191.31-0.37",
    "pǔ":"12:312.83-0.66,314.49-0.57,316.06-0.47,317.53-0.93",
    "pū":"12:271.34-0.58,272.92-0.35,274.27-0.35,275.62-0.39,277.01-0.32",
    "qí":"13:138.56-0.49",
    "qì":"13:127.37-0.41,128.78-0.39",
    "qǐ":"13:181.68-0.53,183.21-0.64,184.85-0.5,186.35-0.51",
    "qī":"13:161.6-0.35,162.94-0.49,164.44-0.41,165.85-0.54",
    "qià":"13:0-0.51,1.51-0.47,2.98-0.59,4.57-0.4",
    "qiā":"13:41.06-0.58,42.64-0.61,44.25-0.43,45.68-0.52,47.2-0.45",
    "qián":"13:11.74-0.72,13.46-0.6,15.06-0.49,16.55-0.57",
    "qiān":"13:48.65-0.52,50.17-0.47,51.64-0.65,53.29-0.41,54.7-0.53",
    "qiàng":"13:5.97-0.43,7.4-0.43,8.83-0.48",
    "qiāng":"13:56.23-0.44,57.67-0.42,59.09-0.45",
    "qiáo":"13:18.12-0.6,19.72-0.43,21.15-0.53,22.68-0.51",
    "qiào":"13:10.31-0.43",
    "qiǎo":"13:77.31-0.57,78.88-0.58,80.45-0.76,82.22-0.53,83.75-0.48",
    "qiāo":"13:60.54-0.45,61.99-0.48,63.47-0.51,64.98-0.48",
    "qié":"13:27.13-0.52,28.65-0.48,30.13-0.61",
    "qiè":"13:24.19-0.45,25.64-0.49",
    "qiě":"13:66.46-0.57,68.03-0.65,69.68-0.58",
    "qín":"13:140.05-0.48",
    "qìn":"13:130.16-0.37,131.54-0.38,132.91-0.42",
    "qīn":"13:167.39-0.41,168.8-0.42,170.22-0.4",
    "qíng":"13:141.53-1.02,143.55-0.54",
    "qìng":"13:134.34-0.46,135.8-0.39,137.19-0.37",
    "qǐng":"13:187.86-0.6,189.46-0.57",
    "qīng":"13:171.62-0.47,173.09-0.42",
    "qióng":"13:31.74-0.48,33.22-0.51,34.72-0.64,36.36-0.64",
    "qiōng":"13:71.26-0.52,72.78-0.5",
    "qiú":"13:38.01-0.49,39.5-0.57",
    "qiǔ":"13:85.23-0.56,86.78-0.58",
    "qiū":"13:74.28-0.57,75.84-0.46",
    "qú":"13:150.6-0.5,152.1-0.58,153.68-0.48,155.16-0.59",
    "qù":"13:145.09-0.37,146.46-0.32,147.78-0.43,149.21-0.39",
    "qǔ":"13:191.03-0.51,192.54-1.68,195.22-0.51,196.73-0.62,198.35-0.59",
    "qū":"13:174.51-0.4,175.91-0.39,177.3-0.46,178.76-0.42",
    "quán":"13:94.16-0.53,95.69-0.63,97.32-0.53,98.85-0.58,100.43-0.51",
    "quàn":"13:88.36-0.52,89.88-0.41,91.29-0.41,92.7-0.46",
    "quǎn":"13:125.81-0.57",
    "quān":"13:110.73-0.5,112.23-0.66,113.89-0.5,115.39-0.63,117.02-0.5",
    "qué":"13:107.7-0.57,109.26-0.47",
    "què":"13:101.94-0.52,103.46-0.35,104.81-0.47,106.28-0.42",
    "quē":"13:118.52-0.39,119.91-0.44,121.35-0.51,122.86-0.47,124.33-0.48",
    "qún":"13:156.75-0.6,158.35-0.54,159.88-0.71",
    "qūn":"13:180.18-0.5",
    "rán":"14:27.3-0.51,28.81-0.43,30.24-0.57",
    "rǎn":"14:97.01-0.64,98.65-0.6,100.25-0.63",
    "ráng":"14:31.8-0.65,33.45-0.53,34.97-0.6,36.58-0.53",
    "ràng":"14:18.96-0.4,20.36-0.43,21.79-0.3,23.09-0.43,24.52-0.45",
    "rǎng":"14:101.88-0.51",
    "ráo":"14:38.11-0.64,39.75-0.56,41.3-0.56",
    "rào":"14:25.97-0.33",
    "rǎo":"14:103.39-0.53,104.92-0.56",
    "rè":"14:42.85-0.46,44.31-0.49,45.8-0.53,47.33-0.4,48.73-0.36",
    "rén":"14:52.9-0.52,54.42-0.51,55.93-0.46,57.39-0.57",
    "rèn":"14:50.09-0.35,51.44-0.46",
    "rěn":"14:93.75-0.51",
    "réng":"14:58.96-0.57",
    "rēng":"14:90.72-0.43,92.15-0.6",
    "rì":"14:60.52-0.37",
    "róng":"14:63.38-0.62,65-0.48",
    "rǒng":"14:106.47-0.5,107.97-1.06",
    "rōng":"14:95.26-0.75",
    "róu":"14:66.48-0.49,67.97-0.6,69.56-0.59,71.16-0.44",
    "ròu":"14:61.89-0.49",
    "rú":"14:81.45-0.44,82.9-0.54,84.44-0.58,86.02-0.59,87.61-0.48",
    "rù":"14:72.59-0.5,74.09-0.47,75.56-0.56,77.12-0.35",
    "rǔ":"14:110.03-0.75,111.78-0.67,113.45-0.64,115.09-0.49,116.58-0.67",
    "ruán":"14:0-0.65",
    "ruǎn":"14:12.37-0.76,14.13-0.72",
    "ruí":"14:3.16-0.66,4.82-0.48",
    "ruì":"14:1.65-0.51",
    "ruǐ":"14:15.85-0.47,17.32-0.64",
    "rún":"14:89.09-0.63",
    "rùn":"14:78.47-0.47,79.94-0.52",
    "ruò":"14:6.3-0.43,7.73-0.4,9.13-0.38,10.51-0.86",
    "sà":"16:52.88-0.48,54.36-0.46,55.82-0.43,57.25-0.74,58.99-0.46",
    "sǎ":"16:202.27-0.71,203.98-0.57",
    "sā":"16:127.62-0.51",
    "sài":"16:60.45-0.42,61.87-0.53,63.4-0.43",
    "sāi":"16:129.13-0.6,130.73-0.61,132.34-0.57,133.9-0.56,135.45-0.56",
    "sàn":"16:64.83-0.54",
    "sǎn":"16:205.55-0.91,207.46-0.62,209.08-0.56,210.63-1.01,212.64-0.72",
    "sān":"16:137-0.56,138.55-0.56,140.1-0.6,141.7-0.54",
    "sàng":"16:66.37-0.53,67.9-0.5,69.4-0.48,70.88-0.51,72.39-0.65",
    "sǎng":"16:214.36-0.57,215.93-0.59",
    "sāng":"16:143.24-0.66",
    "sào":"16:74.04-0.5,75.54-0.4,76.94-0.52,78.46-0.49,79.95-0.65",
    "sǎo":"16:217.52-0.8,219.32-1.02,221.34-0.58,222.92-0.62",
    "sāo":"16:144.9-0.57,146.46-0.48,147.94-0.56,149.49-0.56,151.04-0.57",
    "sè":"16:81.6-0.52,83.12-0.48,84.6-0.47,86.07-0.51,87.58-0.53",
    "sēn":"16:152.61-0.52,154.13-0.67,155.8-0.66,157.46-0.47,158.93-0.58",
    "sēng":"16:160.51-0.67,162.18-0.54,163.72-0.58,165.3-0.47",
    "shá":"15:93.66-0.54,95.2-0.63,96.83-0.54,98.37-0.49",
    "shà":"15:60.05-0.42,61.47-0.43,62.9-0.51,64.41-0.4",
    "shǎ":"15:277.55-0.69,279.24-0.66,280.89-0.83",
    "shā":"15:177.9-0.72,179.62-0.53,181.15-0.67,182.82-0.54,184.36-0.64",
    "shài":"15:65.81-0.53,67.34-0.57,68.9-0.65,70.55-0.6",
    "shāi":"15:186-0.51,187.51-0.53,189.04-0.69,190.73-0.51,192.24-0.59",
    "shàn":"15:72.15-0.4,73.55-0.47,75.02-0.57,76.58-0.62,78.2-0.51",
    "shǎn":"15:282.73-0.68,284.41-0.76,286.17-0.66",
    "shān":"15:193.83-0.73,195.56-0.47,197.03-0.61,198.64-0.62",
    "shàng":"15:79.71-0.56,81.26-0.76,83.02-0.62,84.64-0.62",
    "shǎng":"15:287.83-0.69,289.52-0.63,291.14-0.8,292.95-0.71",
    "shāng":"15:200.26-0.57,201.82-0.54,203.36-0.8,205.16-0.58,206.74-0.7",
    "sháo":"15:99.86-0.56,101.41-0.5",
    "shào":"15:86.26-0.47,87.73-0.56,89.28-0.41,90.69-0.51,92.2-0.46",
    "shǎo":"15:294.66-0.75,296.41-0.74,298.14-0.76,299.91-0.68,301.58-0.78",
    "shāo":"15:208.44-0.62,210.06-0.68,211.74-0.53,213.27-0.64",
    "shé":"15:120.54-0.47,122.01-0.6,123.61-0.49",
    "shè":"15:102.91-0.57,104.47-0.45,105.92-0.86,107.78-0.56,109.33-0.57",
    "shě":"15:243.8-0.7,245.5-0.73",
    "shē":"15:214.91-0.47,216.38-0.57,217.94-0.51,219.45-0.91,221.36-0.57",
    "shéi":"15:125.1-0.61,126.71-0.72,128.43-0.48,129.91-0.49",
    "shén":"15:131.4-1.01,133.41-0.54",
    "shèn":"15:110.9-0.8,112.7-0.71,114.41-0.44,115.85-0.54,117.39-0.46",
    "shěn":"15:247.23-0.79,249.02-0.57,250.59-0.58",
    "shēn":"15:222.92-0.79,224.71-0.61,226.32-0.7,228.02-0.65,229.67-0.67,231.34-0.75,233.09-0.5,234.59-0.67",
    "shéng":"15:134.94-0.65,136.6-0.63,138.22-0.57,139.8-0.74,141.54-0.76",
    "shèng":"15:118.85-0.69",
    "shěng":"15:252.17-0.76,253.93-0.71,255.64-0.5",
    "shēng":"15:236.26-0.5,237.76-0.46,239.22-0.57,240.78-0.44,242.22-0.58",
    "shí":"15:149.66-0.71,151.38-0.66,153.04-0.64,154.68-0.52,156.19-0.52",
    "shì":"15:143.3-0.58,144.88-0.79,146.66-0.54,148.21-0.46",
    "shǐ":"15:303.37-0.84,305.2-0.9,307.11-2.54",
    "shī":"15:257.14-0.59,258.73-0.51,260.24-0.56,261.79-0.5",
    "shóu":"15:166.44-0.71,168.15-0.62,169.77-0.63",
    "shòu":"15:157.72-0.48,159.19-0.5,160.69-1.52,163.22-0.57,164.78-0.66",
    "shǒu":"15:310.64-0.74,312.39-0.65,314.04-0.85,315.89-0.72,317.61-0.76",
    "shōu":"15:263.29-0.54,264.83-0.7,266.52-0.56,268.08-0.66",
    "shú":"15:176.21-0.69",
    "shù":"15:171.4-0.7,173.1-0.53",
    "shǔ":"15:319.37-0.57,320.94-0.8,322.74-0.77",
    "shū":"15:269.74-0.49,271.23-0.67,272.89-0.5,274.39-0.46,275.86-0.69",
    "shuǎ":"15:46.31-0.72,48.03-0.81",
    "shuā":"15:16.84-0.51,18.35-0.42",
    "shuài":"15:0-0.76,1.76-0.41",
    "shuǎi":"15:49.84-0.77,51.61-0.7",
    "shuāi":"15:19.77-0.52,21.29-0.57,22.86-0.58,24.44-0.51",
    "shuàn":"15:3.17-0.51,4.68-0.65",
    "shuān":"15:25.95-0.65,27.6-0.61,29.21-0.68,30.89-0.52",
    "shuǎng":"15:53.31-0.64",
    "shuāng":"15:32.41-0.57,33.97-0.57,35.54-0.54,37.08-0.65,38.73-0.56",
    "shuì":"15:6.33-0.48,7.81-0.43,9.24-0.52",
    "shuǐ":"15:54.95-0.63,56.58-0.73,58.31-0.74",
    "shùn":"15:174.63-0.58",
    "shǔn":"15:324.51-0.73",
    "shuò":"15:10.76-0.56,12.31-0.56,13.86-0.49,15.35-0.49",
    "shuō":"15:40.28-0.46,41.74-0.58,43.32-0.46,44.78-0.53",
    "sì":"16:89.11-0.52,90.63-0.54,92.17-0.4,93.57-0.43,95-0.5,96.5-0.46,97.96-0.54,99.5-0.6",
    "sǐ":"16:224.54-0.8,226.34-0.61,227.95-0.77,229.72-0.57,231.29-0.79",
    "sī":"16:166.77-0.65,168.42-0.57,169.99-0.57,171.55-0.45,173-0.5",
    "sòng":"16:101.1-0.66,102.76-0.41,104.17-0.46",
    "sǒng":"16:233.08-0.67,234.75-0.86,236.61-0.63,238.24-0.94",
    "sōng":"16:174.5-0.56,176.05-0.64,177.69-0.62,179.31-0.67,180.98-0.69",
    "sòu":"16:105.63-0.54,107.17-0.54,108.71-0.49,110.2-0.53,111.73-0.5",
    "sǒu":"16:240.18-0.82,242-0.75,243.75-0.57,245.31-0.94,247.25-0.69",
    "sōu":"16:182.67-0.79,184.46-0.76,186.22-0.49,187.71-0.61",
    "sú":"16:120.76-0.57,122.32-0.59,123.91-0.79,125.7-0.92",
    "sù":"16:113.23-0.47,114.7-0.46,116.16-0.46,117.62-0.66,119.28-0.48",
    "sū":"16:189.32-0.54,190.86-0.62,192.48-0.59,194.07-0.49",
    "suàn":"16:0-0.5,1.5-0.62,3.12-0.47,4.59-0.57,6.15-0.66",
    "suān":"16:20.22-0.66,21.88-0.58,23.46-0.66,25.12-0.48,26.6-0.86",
    "suí":"16:15.41-0.61,17.02-0.64,18.66-0.57",
    "suì":"16:7.81-0.58,9.39-0.43,10.82-0.56,12.37-0.58,13.95-0.46",
    "suǐ":"16:41.27-0.57,42.84-0.68,44.52-0.73,46.25-0.72",
    "suī":"16:28.46-0.57,30.02-0.58,31.6-0.49,33.09-0.82,34.9-0.57",
    "sǔn":"16:248.94-0.67,250.61-0.51",
    "sūn":"16:195.56-0.81,197.37-0.65,199.02-0.58,200.6-0.67",
    "suǒ":"16:47.97-0.57,49.54-0.6,51.14-0.74",
    "suō":"16:36.47-0.5,37.97-0.72,39.7-0.57",
    "tà":"17:113.6-0.36,114.96-0.46,116.42-0.53",
    "tǎ":"17:277.8-0.59,279.39-0.44,280.83-0.57,282.39-0.71",
    "tā":"17:215.07-0.31,216.38-0.38",
    "tái":"17:133.55-0.43,134.97-0.61,136.59-0.47",
    "tài":"17:117.95-0.35,119.3-0.51,120.81-0.43",
    "tāi":"17:217.76-0.52,219.28-0.5,220.78-0.5",
    "tán":"17:138.06-0.63,139.69-0.57,141.25-0.58",
    "tàn":"17:122.24-0.41,123.65-0.58,125.23-0.4",
    "tǎn":"17:284.1-0.5,285.6-0.61",
    "tān":"17:222.28-0.56,223.83-0.51,225.34-0.41,226.75-0.46",
    "táng":"17:142.83-0.51,144.34-0.44",
    "tàng":"17:126.63-0.44",
    "tǎng":"17:287.2-0.61,288.82-0.51,290.33-0.59",
    "tāng":"17:228.21-0.5,229.71-0.47,231.18-0.57,232.75-0.69,234.44-0.46",
    "táo":"17:145.78-0.57,147.35-0.44,148.79-0.45,150.24-0.53",
    "tào":"17:128.07-0.36,129.43-0.31,130.74-0.42,132.16-0.39",
    "tǎo":"17:291.92-0.71,293.63-0.61",
    "tāo":"17:235.9-0.43,237.33-0.39,238.72-0.56,240.27-0.47,241.74-0.62",
    "tè":"17:151.77-0.51,153.28-0.44,154.72-0.44,156.16-0.44,157.6-0.43",
    "téng":"17:159.03-0.54,160.57-0.5,162.07-0.44,163.51-0.48",
    "tí":"17:169.32-0.44,170.76-0.47,172.23-0.62",
    "tì":"17:164.99-0.51,166.5-0.42,167.92-0.4",
    "tǐ":"17:295.24-0.45,296.69-0.61,298.3-0.54",
    "tī":"17:243.36-0.4,244.76-0.39,246.15-0.47,247.62-0.45",
    "tián":"17:6.9-0.59,8.49-0.47,9.96-0.48,11.44-0.56,12.99-0.49",
    "tiàn":"17:0-0.39,1.39-0.35",
    "tiǎn":"17:41.07-0.53,42.6-0.57,44.17-0.56",
    "tiān":"17:23.27-0.51,24.78-0.44,26.22-0.52,27.74-0.56,29.29-0.48",
    "tiáo":"17:14.48-0.54,16.02-0.46",
    "tiào":"17:2.74-0.37,4.11-0.33,5.44-0.46",
    "tiǎo":"17:45.72-0.56,47.27-0.57",
    "tiāo":"17:30.77-0.42,32.19-0.56,33.74-0.48",
    "tiè":"17:17.48-0.56,19.03-0.42,20.45-0.45,21.9-0.37",
    "tiě":"17:39.46-0.61",
    "tiē":"17:35.22-0.37,36.59-0.49,38.08-0.38",
    "tíng":"17:173.85-0.47,175.32-0.54,176.86-0.4,178.26-0.45",
    "tǐng":"17:299.83-0.89,301.73-0.74,303.47-0.46",
    "tīng":"17:249.07-0.42,250.49-0.43,251.92-0.36,253.28-0.45",
    "tóng":"17:190.65-0.59,192.24-0.43,193.67-0.6,195.27-0.75",
    "tòng":"17:179.71-0.51,181.22-0.4,182.62-0.33",
    "tǒng":"17:304.93-0.57,306.49-0.58",
    "tōng":"17:254.73-0.43,256.16-0.38,257.54-0.5,259.04-0.49,260.52-0.5",
    "tóu":"17:197.02-0.51,198.53-0.45,199.98-0.57",
    "tòu":"17:183.95-0.43,185.38-1.55,187.93-0.37,189.3-0.35",
    "tǒu":"17:308.07-0.44,309.51-0.51,311.02-0.52",
    "tōu":"17:262.02-0.46,263.49-0.35,264.83-0.4,266.24-0.51,267.75-0.56",
    "tú":"17:205.81-0.47,207.28-0.42",
    "tù":"17:201.55-0.39,202.94-0.36,204.3-0.51",
    "tǔ":"17:312.54-0.74,314.27-0.47,315.75-0.74",
    "tū":"17:269.3-0.4,270.7-0.35,272.05-0.38",
    "tuán":"17:55.82-0.56,57.37-0.49,58.86-0.48,60.34-0.49",
    "tuàn":"17:48.84-0.35,50.19-0.33,51.52-0.46,52.98-0.38,54.36-0.46",
    "tuǎn":"17:98.07-0.56,99.62-0.53",
    "tuān":"17:83.8-0.51,85.31-0.49,86.8-0.41,88.21-0.42,89.63-0.4",
    "tuí":"17:65.97-0.61,67.58-0.54,69.12-0.5,70.62-0.45",
    "tuì":"17:61.83-0.34,63.17-0.42,64.59-0.38",
    "tuǐ":"17:101.15-0.49,102.64-0.61,104.25-0.52,105.77-0.48,107.25-0.6",
    "tuī":"17:91.03-0.38,92.41-0.44,93.85-0.45,95.3-0.42",
    "tún":"17:208.7-0.49,210.19-0.52,211.71-0.54,213.25-0.82",
    "tūn":"17:273.43-0.52,274.95-0.38,276.33-0.47",
    "tuó":"17:77.8-0.43,79.23-0.45,80.68-0.54,82.22-0.58",
    "tuò":"17:72.07-0.46,73.53-0.38,74.91-0.36,76.27-0.53",
    "tuǒ":"17:108.85-0.57,110.42-0.63,112.05-0.56",
    "tuō":"17:96.72-0.35",
    "wá":"18:20.23-0.53,21.76-0.59,23.35-0.46,24.81-0.56,26.36-0.61",
    "wà":"18:0-0.45,1.45-0.43,2.88-0.36,4.24-0.38",
    "wǎ":"18:113.47-0.5,114.97-0.73,116.7-0.54",
    "wā":"18:60.98-0.57,62.54-0.51,64.05-0.5,65.55-0.51,67.06-0.39",
    "wài":"18:5.62-0.45,7.07-0.41,8.48-0.42",
    "wǎi":"18:118.24-0.65,119.89-0.9,121.79-0.73",
    "wāi":"18:68.45-0.46,69.91-0.57,71.47-0.47",
    "wán":"18:27.97-0.57,29.53-0.56",
    "wàn":"18:9.9-0.47,11.37-0.56,12.92-0.5",
    "wǎn":"18:123.52-0.58,125.1-0.56",
    "wān":"18:72.94-0.57,74.51-0.45,75.95-0.47,77.43-0.5",
    "wáng":"18:31.08-0.57",
    "wàng":"18:14.42-0.48,15.9-0.42,17.32-0.41,18.73-0.5",
    "wǎng":"18:126.65-0.6,128.25-0.51",
    "wāng":"18:78.93-0.53,80.45-0.79,82.25-0.7,83.95-0.49,85.44-0.52",
    "wéi":"18:44.21-0.56",
    "wèi":"18:32.65-0.49,34.14-0.4,35.54-0.37",
    "wěi":"18:98.96-0.51,100.47-0.47",
    "wēi":"18:86.96-0.49,88.45-0.39,89.84-0.43,91.27-0.45",
    "wén":"18:45.76-0.77,47.53-0.54,49.07-0.43,50.5-0.54",
    "wèn":"18:36.91-0.33,38.24-0.4,39.64-0.5",
    "wěn":"18:101.94-0.65",
    "wēn":"18:92.72-0.5,94.22-0.45,95.67-0.56",
    "wèng":"18:41.14-0.57,42.7-0.51",
    "wěng":"18:103.59-0.49",
    "wēng":"18:97.22-0.74",
    "wò":"18:52.04-0.44",
    "wǒ":"18:129.76-0.54",
    "wō":"18:105.08-0.49,106.57-0.41,107.98-0.35",
    "wú":"18:57.97-0.47,59.44-0.54",
    "wù":"18:53.48-0.59,55.07-0.51,56.58-0.39",
    "wǔ":"18:131.3-0.51,132.81-0.57",
    "wū":"18:109.33-0.49,110.82-0.31,112.13-0.34",
    "xí":"19:147.15-0.61,148.76-0.85,150.61-0.71",
    "xì":"19:131.93-0.5,133.43-0.56,134.98-0.49",
    "xǐ":"19:202.31-0.6,203.91-0.62",
    "xī":"19:173.04-0.53,174.57-0.47,176.04-0.41,177.45-0.6,179.05-0.58",
    "xiá":"19:13.68-0.61,15.29-0.54",
    "xià":"19:0-0.51,1.51-0.45,2.96-0.43",
    "xiā":"19:47.41-0.64,49.05-0.47,50.52-0.47,51.99-0.57,53.55-0.52",
    "xián":"19:16.82-0.68,18.51-0.75,20.26-0.91,22.17-0.79",
    "xiàn":"19:4.39-0.56,5.94-0.54,7.48-0.51",
    "xiǎn":"19:78.66-0.73,80.39-0.7",
    "xiān":"19:55.07-0.46",
    "xiáng":"19:23.96-0.61,25.57-0.64,27.21-0.72",
    "xiàng":"19:8.99-0.5,10.49-0.59",
    "xiǎng":"19:82.09-0.52,83.61-0.66,85.27-0.76",
    "xiāng":"19:56.53-0.45,57.98-0.52,59.5-0.52,61.02-0.58",
    "xiáo":"19:28.93-0.64,30.57-0.62",
    "xiào":"19:12.08-0.6",
    "xiǎo":"19:87.03-0.76,88.79-0.59,90.38-0.87",
    "xiāo":"19:62.6-0.72,64.32-0.65",
    "xié":"19:38.14-0.64,39.78-0.53,41.31-0.57",
    "xiè":"19:32.19-0.52,33.71-0.43,35.14-0.51,36.65-0.49",
    "xiě":"19:69.16-0.62",
    "xiē":"19:65.97-0.61,67.58-0.58",
    "xìn":"19:136.47-0.46,137.93-0.49,139.42-0.51,140.93-0.5,142.43-0.67",
    "xīn":"19:180.63-0.54,182.17-0.48,183.65-0.58,185.23-0.49,186.72-0.68",
    "xíng":"19:152.32-0.59,153.91-0.53,155.44-0.52,156.96-0.53",
    "xìng":"19:144.1-0.63,145.73-0.42",
    "xǐng":"19:205.53-0.75,207.28-0.81,209.09-0.76",
    "xīng":"19:188.4-0.6,190-0.52,191.52-0.57",
    "xióng":"19:44.4-0.57,45.97-0.44",
    "xiòng":"19:42.87-0.53",
    "xiōng":"19:70.78-0.6,72.38-0.58,73.96-0.75",
    "xiǔ":"19:92.25-0.65,93.9-0.63,95.53-0.77,97.3-0.66",
    "xiū":"19:75.71-0.5,77.21-0.45",
    "xú":"19:163.21-0.6,164.81-0.62",
    "xù":"19:158.49-0.49,159.98-0.65",
    "xǔ":"19:210.85-0.6,212.45-0.73,214.18-0.52,215.7-0.64",
    "xū":"19:193.09-0.53,194.62-0.52,196.14-0.44,197.58-0.51,199.09-0.68",
    "xuán":"19:102.3-0.66,103.96-0.64,105.6-0.65",
    "xuàn":"19:98.96-0.57,100.53-0.77",
    "xuǎn":"19:126.79-0.74,128.53-0.69,130.22-0.71",
    "xuān":"19:112.01-0.61,113.62-0.78,115.4-0.65",
    "xué":"19:108.84-0.47,110.31-0.7",
    "xuè":"19:107.25-0.59",
    "xuě":"19:121.77-0.65,123.42-0.69,125.11-0.68",
    "xuē":"19:117.05-0.57,118.61-0.68,120.29-0.48",
    "xún":"19:166.43-0.61,168.04-0.67,169.71-0.69,171.4-0.64",
    "xùn":"19:161.63-0.58",
    "xūn":"19:200.77-0.54",
    "yá":"20:51.77-0.44,53.21-0.53",
    "yà":"20:34.26-0.44,35.7-0.53,37.22-0.41,38.64-0.47,40.11-0.46",
    "yǎ":"20:109.59-0.51,111.1-0.7",
    "yā":"20:86.39-0.46,87.85-0.51,89.36-0.43",
    "yán":"20:54.74-0.46,56.2-0.44,57.64-0.57",
    "yàn":"20:41.57-0.49,43.06-0.41,44.47-0.41,45.88-0.47",
    "yǎn":"20:112.8-0.57",
    "yān":"20:90.79-0.43,92.22-0.4,93.62-0.45,95.07-0.36",
    "yáng":"20:59.2-0.74,60.94-0.46,62.4-0.56,63.95-0.44",
    "yàng":"20:47.35-0.46,48.81-0.5,50.31-0.46",
    "yǎng":"20:114.36-0.56,115.91-0.45,117.36-0.63,118.99-0.53,120.52-0.62",
    "yāng":"20:96.43-0.54,97.97-0.35,99.32-0.44",
    "yáo":"20:65.39-0.43,66.81-0.45",
    "yǎo":"20:122.14-0.64,123.78-0.48,125.26-0.56,126.81-0.49,128.3-0.5",
    "yú":"20:77.02-0.5,78.52-0.5,80.02-0.45",
    "yù":"20:68.27-0.72,69.98-0.29,71.28-0.41",
    "yǔ":"20:129.8-0.51,131.31-0.66,132.97-0.57",
    "yū":"20:100.76-0.5,102.26-0.48,103.74-0.31",
    "yuán":"20:8.13-0.71,9.84-0.56,11.39-0.57,12.95-0.51,14.46-0.57",
    "yuàn":"20:0-0.63,1.63-0.47,3.1-0.48,4.58-1.01,6.59-0.54",
    "yuǎn":"20:31.05-0.74,32.79-0.47",
    "yuān":"20:20.41-0.5,21.91-0.63,23.54-0.52",
    "yuè":"20:16.03-0.42,17.45-0.5,18.95-0.46",
    "yuē":"20:25.06-0.49,26.55-0.52,28.07-0.5,29.57-0.48",
    "yún":"20:81.47-0.47,82.94-0.96,84.9-0.49",
    "yùn":"20:72.69-0.42,74.11-0.5,75.61-0.41",
    "yǔn":"20:134.54-0.64,136.18-0.48",
    "yūn":"20:105.05-0.4,106.45-0.59,108.04-0.56",
    "zá":"21:241.62-0.56,243.17-0.56,244.72-0.43,246.15-0.51",
    "zǎ":"21:353.04-0.44,354.48-0.57,356.04-0.4,357.44-0.57",
    "zā":"21:305.94-0.37,307.31-0.49,308.8-0.35",
    "zài":"21:220.8-0.42,222.22-0.35,223.57-0.3,224.87-0.31",
    "zǎi":"21:359-1.76,361.76-0.62,363.38-0.57",
    "zāi":"21:310.15-0.46,311.61-0.37,312.98-0.38,314.36-0.49,315.85-0.52",
    "zán":"21:247.66-0.51,249.17-0.45,250.62-0.38,252-0.44,253.44-0.49",
    "zàn":"21:226.18-0.33,227.51-0.45,228.96-0.44,230.4-0.43",
    "zǎn":"21:364.94-0.42,366.36-0.57,367.92-0.4,369.32-0.48",
    "zān":"21:317.37-0.4,318.77-0.46,320.23-0.46,321.69-0.46",
    "zàng":"21:231.83-0.44,233.27-0.43,234.7-0.41",
    "zāng":"21:323.14-0.46,324.61-0.41,326.02-0.34,327.36-0.42",
    "záo":"21:254.93-0.51,256.44-0.44",
    "zào":"21:236.11-0.43,237.54-0.37,238.91-0.32,240.23-0.39",
    "zǎo":"21:370.8-0.48,372.28-0.52,373.8-0.79,375.59-0.54,377.13-0.41",
    "zāo":"21:328.78-0.48,330.26-0.56",
    "zé":"21:271.77-0.38,273.14-0.41,274.56-0.44,276-0.51",
    "zè":"21:257.88-0.36,259.24-0.35,260.58-0.49",
    "zéi":"21:277.51-0.51,279.02-0.51,280.52-0.47,282-0.54",
    "zèn":"21:262.08-0.38,263.45-0.59,265.05-0.32,266.37-0.35",
    "zěn":"21:337.46-0.51,338.97-0.4",
    "zèng":"21:267.72-0.32,269.04-0.34,270.38-0.39",
    "zēng":"21:331.81-0.38,333.19-0.57,334.75-0.33,336.08-0.38",
    "zhá":"21:37.04-0.34,38.38-0.3",
    "zhà":"21:0-0.32,1.32-0.31,2.63-0.34,3.97-0.34,5.31-0.29",
    "zhǎ":"21:176.73-0.58",
    "zhā":"21:100.28-0.36,101.64-0.33,102.97-0.44,104.41-0.39,105.8-0.33",
    "zhái":"21:39.68-0.43,41.11-0.51,42.62-0.66",
    "zhài":"21:6.59-0.4,7.99-0.33,9.32-0.45,10.77-0.45,12.22-0.41",
    "zhǎi":"21:178.31-0.64",
    "zhāi":"21:107.13-0.31,108.44-0.46,109.9-0.36,111.26-0.36",
    "zhàn":"21:13.63-0.4,15.03-0.46,16.49-0.31,17.8-0.42,19.22-0.4,20.62-0.32,21.94-0.43,23.37-0.36",
    "zhǎn":"21:179.95-0.46,181.41-0.53,182.94-0.51,184.45-0.62",
    "zhān":"21:112.62-0.49,114.11-0.39,115.5-0.54,117.04-0.46",
    "zhàng":"21:24.73-0.46,26.19-0.33,27.52-0.38,28.9-0.35",
    "zhǎng":"21:186.07-0.46,187.53-0.48,189.01-0.57,190.57-0.57",
    "zhāng":"21:118.5-0.46,119.96-0.33,121.29-0.39,122.68-0.39,124.07-0.43",
    "zháo":"21:44.28-0.34",
    "zhào":"21:30.25-0.41,31.66-0.3,32.96-0.34,34.3-0.35,35.65-0.39",
    "zhǎo":"21:192.14-0.54,193.68-0.44,195.12-0.47,196.59-0.5",
    "zhāo":"21:125.5-0.41,126.91-0.57,128.47-0.42",
    "zhé":"21:64.56-0.39,65.95-0.41,67.36-0.4,68.76-0.41",
    "zhè":"21:45.62-0.3,46.92-0.31",
    "zhě":"21:144.47-0.47,145.94-0.43,147.38-0.47",
    "zhē":"21:129.9-0.5",
    "zhèn":"21:48.23-0.41,49.64-0.35,50.99-0.35,52.34-0.41,53.75-0.32",
    "zhěn":"21:148.85-0.4,150.25-0.57,151.82-0.38,153.19-0.43",
    "zhēn":"21:131.4-0.5,132.9-0.35,134.25-0.66,135.91-0.51",
    "zhèng":"21:55.07-0.34,56.41-0.33,57.74-0.31,59.05-0.43,60.48-0.34,61.82-0.42,63.24-0.32",
    "zhěng":"21:154.63-0.41,156.04-0.41",
    "zhēng":"21:137.41-0.56,138.97-0.34,140.31-0.36,141.66-0.44,143.11-0.37",
    "zhí":"21:75.51-0.43,76.94-0.36,78.3-0.41,79.7-0.48,81.19-0.45,82.64-0.42",
    "zhì":"21:70.17-0.37,71.54-0.32,72.86-0.3,74.16-0.35",
    "zhǐ":"21:198.09-0.47,199.56-0.5,201.06-0.49,202.55-0.41,203.96-0.52",
    "zhī":"21:157.44-0.36,158.81-0.34,160.15-0.29,161.44-0.43",
    "zhòng":"21:84.06-0.34,85.4-0.3,86.7-0.3,88-0.34,89.34-0.36,90.7-0.52,92.22-0.32",
    "zhǒng":"21:205.48-0.49,206.97-0.49,208.46-0.75,210.21-0.45,211.66-0.45",
    "zhōng":"21:162.87-0.36,164.23-0.4,165.63-0.37,167-0.32,168.32-0.4",
    "zhóu":"21:98.87-0.41",
    "zhòu":"21:93.54-0.3,94.84-0.38,96.22-0.34,97.56-0.31",
    "zhǒu":"21:213.11-0.42,214.53-0.76,216.29-0.47,217.76-0.5,219.26-0.54",
    "zhōu":"21:169.72-0.38,171.1-0.5,172.6-0.47,174.07-0.33,175.4-0.33",
    "zì":"21:283.54-0.33,284.87-0.41,286.27-0.32,287.6-0.37,288.97-0.45,290.42-0.35,291.77-0.38",
    "zǐ":"21:378.54-0.53,380.07-0.59,381.66-1.01,383.67-0.44",
    "zī":"21:340.37-0.35,341.72-0.5,343.22-0.36,344.58-0.35",
    "zòng":"21:293.14-0.32,294.47-0.61,296.08-0.34,297.42-0.38",
    "zǒng":"21:385.11-0.53,386.64-0.59,388.23-0.62,389.85-0.5",
    "zōng":"21:345.93-0.36,347.29-0.38,348.67-0.47,350.14-0.56",
    "zòu":"21:298.8-0.48,300.27-0.6,301.88-0.3,303.18-0.3,304.48-0.46",
    "zǒu":"21:391.35-0.4,392.75-0.56,394.3-0.44,395.74-0.48",
    "zōu":"21:351.69-0.35"
  },
  "spriteFiles":[
    "pinyin-b-159033946119.m4a",
    "pinyin-ch-b51df5bbdf31.m4a",
    "pinyin-c-2d9e5f2f4b25.m4a",
    "pinyin-d-36e045a5d3c7.m4a",
    "pinyin-f-74c9cb621dda.m4a",
    "pinyin-g-798e2bbe5008.m4a",
    "pinyin-h-2382b2a85306.m4a",
    "pinyin-j-fe92bccc2039.m4a",
    "pinyin-k-6d389f8b2027.m4a",
    "pinyin-l-b526029ad86f.m4a",
    "pinyin-m-4b1279912df4.m4a",
    "pinyin-n-3062f0617339.m4a",
    "pinyin-p-b8e74b904caf.m4a",
    "pinyin-q-92998af6d01b.m4a",
    "pinyin-r-16fedfef9b82.m4a",
    "pinyin-sh-a2bcf0384abf.m4a",
    "pinyin-s-3d4fff5cbad4.m4a",
    "pinyin-t-67a04415c520.m4a",
    "pinyin-w-15ccde7b1249.m4a",
    "pinyin-x-a3ac0fd26675.m4a",
    "pinyin-y-46b4bf76812d.m4a",
    "pinyin-z-65e3e200a635.m4a",
    "pinyin-a,ā,á,ǎ,à-b17c99d493fa.m4a",
    "pinyin-ē,é,ě,è-986e32e1fc6c.m4a",
    "pinyin-ō,ǒ,ò-4844db90dc3b.m4a"
  ]
}